import React, {Component} from 'react';
import { TextField, List, ListItem, ListItemText, FormHelperText, TableRow } from "@mui/material";
import firebase from "./../firebase";
//import $ from 'jquery'; './jquery.dataTables.min.css';
import ReactJWPlayer from 'react-jw-player';
// eslint-disable-next-line import/no-webpack-loader-syntax
//import Captions from "file-loader!../assets/sub/Avatar_2009_sub_ro.vtt";
import $, { data } from 'jquery';
import moment from 'moment';
import Select from 'react-select';
//import 'react-select-2/dist/css/react-select-2.css';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";
import VideoJS from './VideoJS';

//const $ = require('jquery');
$.DataTable = require('datatables.net');
const axios = require('axios');

export default class Bodycontenttvjw extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            role: '',
            count:0,
            count_logs: 0,
            myip: '',
            mylocation: '',
            channels: [],
            all_channels: [],
            datatable: [],
            addsopcast: 'sop://broker.sopcast.com:3912/6002',
            addtitlesopcast: 'CCV5',
            playlist: 'https://stream.adunity.com/b1/b1_640-.m3u8',
            videoTitle: '',
            avatar_sub:false,
            avatar_movie:false,
            gladiator_movie:false,
            independanceday_movie:false,
            starwarssoloastory_movie:false,
            intime_movie:false,
            bornastar_movie:false,
            prettywoman_movie:false,
            basicinstinct_movie:false,
            basicinstincttwo_movie:false,
            doubleimpact_movie:false,
            rockyfive_movie:false,
            thetitan_movie:false,
            thematrixrevolutions_movie:false,
            thematrixreloaded_movie:false,
            frozentwo_movie:false,
            oblivion_movie:false,
            spiderman_movie:false,
            spidermantwo_movie:false,
            legionnaire_movie:false,
            agooddaytodiehard_movie:false,
            thehardcorps_movie:false,
            irobot_movie:false,
            robocopthree_movie:false,
            robocop_movie:false,
            diehard_movie:false,
            missionimpossible_movie:false,
            titanic_movie:false,
            shooter_movie:false,
            troia_movie:false,
            martian_movie:false,
            thedayaftertomorow_movie:false,
            thorthedarkworld_movie:false,
            douamiidoisprezece_movie:false,
            the5thwave_movie:false,
            godzilla_movie:false,
            firstman_movie:false,
            ironman_movie:false,
            grizzlyman_movie:false,
            imlegend_movie:false,
            thelegendofhercules_movie:false,
            thelegendoftarzan_movie:false,
            thelegendofzorro_movie:false,
            fistsoflegend_movie:false,
            americanson_movie:false,
            firststrike_movie:false,
            anaconda_movie:false,
            anacondathree_movie:false,
            theedge_movie:false,
            countdown_movie:false,
            theinvisibleman_movie:false,
            invisible_movie:false,
            theweatherman_movie:false,
            ghostrider_movie:false,
            firefire_movie:false,
            cityofangels_movie:false,
            constantine_movie:false,
            constantineold_movie:false,
            stepup_movie:false,
            supermanreturns_movie:false,
            adangerousman_movie:false,
            frozenfever_movie:false,
            copland_movie:false,
            thefugitive_movie:false,
            looper_movie:false,
            greenzone_movie:false,
            warfortheplanetoftheapes_movie:false,
            beyondareasonabledoubt_movie:false,
            riseoftheplanetoftheapes_movie:false,
            goodkill_movie:false,
            thehuntingparty_movie:false,
            americansniper_movie:false,
            criminal_movie:false,
            exodus_movie:false,
            startrekintodarkness_movie:false,
            kursk_movie:false,
            war_movie:false,
            hartswar_movie:false,
            jungle_movie:false,
            piratesofthecaribbean_movie:false,
            guardiansofthegalaxy_movie:false,
            guardiansofthegalaxytwo_movie:false,
            sniperthree_movie:false,
            patriotsday_movie:false,
            motherlessbrooklyn_movie:false,
            terminator_movie:false,
            firststriketwo_movie:false,
            fortysevenmetersdown_movie:false,
            whitehousedown_movie:false,
            transformers_movie:false,
            stargate_movie:false,
            noah_movie:false,
            oursoulsatnight_movie:false,
            transformerstwo_movie:false,
            equalstandard_movie:false,
            starwarstheriseofskywalker_movie:false,
            perfectsense_movie:false,
            regardinghenry_movie:false,
            theimmigrant_movie:false,
            themazerunner_movie:false,
            pointbreak_movie:false,
            threehundred_movie:false,
            dunkirk_movie:false,
            threehundredtwo_movie:false,
            insurgent_movie:false,
            extinction_movie:false,
            thecore_movie:false,
            sevenyearsintibet_movie:false,
            universalsoldier_movie:false,
            partyharddieyoung_movie:false,
            behindenemylines_movie:false,
            alienoverlords_movie:false,
            themummy_movie:false,
            burnout_movie:false,
            darc_movie:false,
            elysium_movie:false,
            xmentwo_movie:false,
            iceman_movie:false,
            drailed_movie:false,
            thecorrupted_movie:false,
            destroyer_movie:false,
            aravindasamethaveeraraghava_movie:false,
            thewheel_movie:false,
            theoutsider_movie:false,
            interrogation_movie:false,
            momentum_movie:false,
            thecutlass_movie:false,
            secretintheireyes_movie:false,
            frompariswithlove_movie:false,
            insidemanmostwanted_movie:false,
            goyotheboygeneral_movie:false,
            thecurrentwar_movie:false,
            xmendaysoffuturepast_movie:false,
            allegiant_movie:false,
            ichi_movie:false,
            avpalienvspredator_movie:false,
            kingdomofheaven_movie:false,
            ghostsofwar_movie:false,
            theplatform_movie:false,
            battlescars_movie:false,
            bloodandglory_movie:false,
            bloodfather_movie:false,
            hoursthesecretsoldiersofbenghazi_movie:false,
            thefinesthours_movie:false,
            aux_movie:false,
            ayogya_movie:false,
            thedirective_movie:false,
            elchicano_movie:false,
            mymother_movie:false,
            firstlove_movie:false,
            drinkslaylove_movie:false,
            thewholetruth_movie:false,
            ashesinthesnow_movie:false,
            capsule_movie:false,
            paloalto_movie:false,
            moffie_movie:false,
            thebeastinthejungle_movie:false,
            thebirdcatchersson_movie:false,
            bharat_movie:false,
            thewolves_movie:false,
            godblessthebrokenroad_movie:false,
            thespacewalker_movie:false,
            justiceleaguevsthefatalfive_movie:false,
            xmenapocalypse_movie:false,
            earthandblood_movie:false,
            theshallows_movie:false,
            thehuntressruneofthedead_movie:false,
            highlife_movie:false,
            parasite_movie:false,
            crucibleofthevampire_movie:false,
            jinn_movie:false,
            angelhasfallen_movie:false,
            aroughdraft_movie:false,
            coldground_movie:false,
            mandy_movie:false,
            draculauntold_movie:false,
            widowswalk_movie:false,
            us_movie:false,
            therevenant_movie:false,
            thedarktower_movie:false,
            apocalypto_movie:false,
            replace_movie:false,
            alienimplant_movie:false,
            fantasticfour_movie:false,
            fantasticfourtwo_movie:false,
            hercules_movie:false,
            gijoetheriseofcobra_movie:false,
            captainamericacivilwar_movie:false,
            minotaur_movie:false,
            krampusorigins_movie:false,
            behindyou_movie:false,
            theunborn_movie:false,
            flightsixhundredsixtysix_movie:false,
            prideandprejudiceandzombies_movie:false,
            loveinwinterland_movie:false,
            wintercastle_movie:false,
            memoirsofageisha_movie:false,
            sonofsaul_movie:false,
            thedouble_movie:false,
            sgtwillgardner_movie:false,
            wherehandstouch_movie:false,
            zombies_movie:false,
            alienvszombies_movie:false,
            erniejoe_movie:false,
            painandglory_movie:false,
            afantasticwoman_movie:false,
            stormboy_movie:false,
            thecrow_movie:false,
            momentumgeneration_movie:false,
            thesecretdaretodream_movie:false,
            ifyouaregone_movie:false,
            hunterkiller_movie:false,
            ghostintheshell_movie:false,
            replicas_movie:false,
            beetlejuice_movie:false,
            monsterhouse_movie:false,
            carrie_movie:false,
            corpsebride_movie:false,
            halloween_movie:false,
            it_movie:false,
            transformersrevengeofthefallen_movie:false,
            itchaptertwo_movie:false,
            poseidon_movie:false,
            timetrap_movie:false,
            thecloverfieldparadox_movie:false,
            thetimetravelerswife_movie:false,
            thegateway_movie:false,
            projectpower_movie:false,
            nightatthemuseumsecretofthetomb_movie:false,
            passengers_movie:false,
            venom_movie:false,
            lucy_movie:false,
            alpha_movie:false,
            avatartwo_movie:false,
            atlas_movie:false,
            newuniverseadult_movie:false, //end movies
            autostart:true,
            jwplayer:true,
            videoplayer:false,
            videoadultplayer:false,
            videojsshow:false,
            videoJsOptions:{
              autoplay: false,
              controls: true,
              responsive: true,
              fluid: true,
              sources: [],
              tracks: [],
            },          
            jwtcategory:[
              {
                'id': 1,
                'title': 'TV Channels',
                'description': 'Description of TV Channels'
              },
              {
                'id': 2,
                'title': 'Adult TV Channels',
                'description': 'Description of Adult TV Channels'
              },
              {
                'id': 3,
                'title': 'Movies Channels',
                'description': 'Description of Movies Channels'
              },
              {
                'id': 4,
                'title': 'Adult Movie Channels',
                'description': 'Description of Adult Movie Channels'
              },
            ],
            jwtsubcategory:[
              {
                'id': 1,
                'title': 'SF',
                'description': 'Science Fiction'
              },
              {
                'id': 2,
                'title': 'Love',
                'description': 'Love'
              },
              {
                'id': 3,
                'title': 'Documentary',
                'description': 'Documentary'
              },
              {
                'id': 4,
                'title': 'Childs',
                'description': 'Childs'
              },
            ],
            countjwtcategory:0,
            countjwtsubcategory:0,
            jwtcategories:0,
            jwtsubcategories:'',
            selectoptions:[],
            rezumat:'Canal TV Stiri',
            denumireselectie:'',
            carouselitems:[],
            width: 0, 
            height: 0,
            radiocheckedone: true,
            radiocheckedtwo: false,
            radiocheckedthree: false,
            radiocheckedfour: false,
            radioselect: '',
            currentPage: 1,
            itemsPerPage: 5,
            upperPageBound: 3,
            lowerPageBound: 0,
            isPrevBtnActive: 'disabled',
            isNextBtnActive: '',
            pageBound: 3
        };
    
        this.onAdPlay = this.onAdPlay.bind(this);
        this.onReady = this.onReady.bind(this);
        this.onVideoLoad = this.onVideoLoad.bind(this);
    
        // each instance of <ReactJWPlayer> needs a unique id.
        // we randomly generate it here and assign to the container instance.
        this.playerId = '123456';
        var Select = require('react-select');

        this.handleClick = this.handleClick.bind(this);
        this.btnDecrementClick = this.btnDecrementClick.bind(this);
        this.btnIncrementClick = this.btnIncrementClick.bind(this);
        this.btnNextClick = this.btnNextClick.bind(this);
        this.btnPrevClick = this.btnPrevClick.bind(this);
        // this.componentDidMount = this.componentDidMount.bind(this);
        this.setPrevAndNextBtnClass = this.setPrevAndNextBtnClass.bind(this);
    }

    onReady(event) {
      // interact with JW Player API here
      const player = window.jwplayer(this.playerId);
    }
    onAdPlay(event) {
      // track the ad play here
    }
    onVideoLoad(event) {
      this.setState({
        videoTitle: event.item.description // this only works with json feeds!
      });
    }

    updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    handleClick(event) {
      let listid = Number(event.target.id);
      this.setState({
        currentPage: listid
      });
      $("ul li.active").removeClass('active');
      $('ul li#'+listid).addClass('active');
      this.setPrevAndNextBtnClass(listid);
    }
    setPrevAndNextBtnClass(listid) {
      let totalPage = Math.ceil(this.state.carouselitems.length / this.state.itemsPerPage);
      this.setState({isNextBtnActive: 'disabled'});
      this.setState({isPrevBtnActive: 'disabled'});
      if(totalPage === listid && totalPage > 1){
          this.setState({isPrevBtnActive: ''});
      }
      else if(listid === 1 && totalPage > 1){
          this.setState({isNextBtnActive: ''});
      }
      else if(totalPage > 1){
          this.setState({isNextBtnActive: ''});
          this.setState({isPrevBtnActive: ''});
      }
  }
    btnIncrementClick() {
        this.setState({upperPageBound: this.state.upperPageBound + this.state.pageBound});
        this.setState({lowerPageBound: this.state.lowerPageBound + this.state.pageBound});
        let listid = this.state.upperPageBound + 1;
        this.setState({ currentPage: listid});
        this.setPrevAndNextBtnClass(listid);
  }
    btnDecrementClick() {
      this.setState({upperPageBound: this.state.upperPageBound - this.state.pageBound});
      this.setState({lowerPageBound: this.state.lowerPageBound - this.state.pageBound});
      let listid = this.state.upperPageBound - this.state.pageBound;
      this.setState({ currentPage: listid});
      this.setPrevAndNextBtnClass(listid);
  }
  btnPrevClick() {
      if((this.state.currentPage -1)%this.state.pageBound === 0 ){
          this.setState({upperPageBound: this.state.upperPageBound - this.state.pageBound});
          this.setState({lowerPageBound: this.state.lowerPageBound - this.state.pageBound});
      }
      let listid = this.state.currentPage - 1;
      this.setState({ currentPage : listid});
      this.setPrevAndNextBtnClass(listid);
      //alert(this.state.currentPage);
      //$('ul.pagination li.active').removeClass('active');
      $('ul.pagination li#'+(this.state.currentPage-1)+' button#'+(this.state.currentPage-1)).addClass('active');
  }
  btnNextClick() {
      if((this.state.currentPage +1) > this.state.upperPageBound ){
          this.setState({upperPageBound: this.state.upperPageBound + this.state.pageBound});
          this.setState({lowerPageBound: this.state.lowerPageBound + this.state.pageBound});
      }
      let listid = this.state.currentPage + 1;
      this.setState({ currentPage : listid});
      this.setPrevAndNextBtnClass(listid);
      //alert(this.state.currentPage);
      //$('ul.pagination li.active').removeClass('active');
      $('ul.pagination li#'+(this.state.currentPage+1)+' button#'+(this.state.currentPage+1)).addClass('active');
  }

  handlePlayerReady(player) {
    console.log('Player is ready:', player);
    player.volume(1);
  };

    componentDidMount() {
      //alert(localStorage.getItem('user_id'))
      window.addEventListener("resize", this.updateWindowDimensions());
      $('ul.pagination li.active').removeClass('active');
      $('ul.pagination li#'+this.state.currentPage+' button#'+this.state.currentPage).addClass('active');
      this.getUser()
      this.setCategory_jwt_category()
      this.setCategory_jwt_subcategory()
      this.logs()
      //alert(btoa('meserie:test20200801'))
      const auth = 'Basic '+btoa('meserie:test20200801');
      /*fetch('https://diskoteka.ro/apitickets/channelstv/all',{
        //mode: 'no-cors',
        method: 'GET',
        headers: new Headers({
          'Accept': auth, 
          'Content-Type': 'text/plain'
        })})
        .then(blob => blob.json())
        .then((data)=> {
          //alert(JSON.stringify(data))
          //var data = res.json()
          //console.log(JSON.stringify(data))
          //const data=1;
          if(data.length>1){
            //console.log(JSON.stringify(data))
            this.setState({ channels: data })
            this.setCarouselItems()
            var select_options = []
            firebase.database().ref("/channelstv_jwt").remove()
            data.forEach(child => {
            var refdb = firebase.database().ref('/channelstv_jwt').push();
            refdb = refdb.toString().slice(-20);
            let updateData = firebase.database().ref("/channelstv_jwt").child(refdb);
            updateData.child("id").set(child.id);
            updateData.child("denumire").set(child.denumire);
            updateData.child("adresa").set(child.adresa);
            updateData.child("adresatwo").set(child.adresatwo);
            updateData.child("category").set(child.category);
            updateData.child("description").set(child.description);
            updateData.child("subcategory").set(child.subcategory);
            updateData.child("image").set(child.image);
            updateData.child("year").set(child.year);
            updateData.child("status").set(child.status);
            select_options.push({
              value: child.id,
              label: child.denumire
            })
            })
            this.setState({ selectoptions: select_options })
          }else{
            firebase.database().ref("/channelstv_jwt").on('value', snapshot => {
              var channelstv_jwt = []
              var select_options = []
              snapshot.forEach(child => {
                var data = child.val()
                  channelstv_jwt.push({
                    id: data.id,
                    denumire: data.denumire,
                    adresa: data.adresa,
                    adresatwo: data.adresatwo,
                    adresathree: data.adresathree,
                    category: data.category,
                    description: data.description,
                    subcategory: data.subcategory,
                    image: data.image,
                    year: data.year,
                    imdb: data.imdb,
                    status: data.status
                  })
                  select_options.push({
                    value: data.id,
                    label: data.denumire
                  })
              this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt, selectoptions: select_options })
              this.setCarouselItems()
            })
          })
          }
          this.setState({
            all_channels: this.state.channels
          });
          setTimeout(function(){ 
          if(this.state.role === '"adminc"'){
            //alert('Adminc');
            //alert(this.state.role);
            var channelstv_jwt = [] 
            this.state.channels.forEach(data => {
              //alert(data.category);
              if((parseInt(data.category) !== 2) && (parseInt(data.category) !== 4)){
              //  alert(data.category);
              channelstv_jwt.push({
                id: data.id,
                denumire: data.denumire,
                adresa: data.adresa,
                adresatwo: data.adresatwo,
                adresathree: data.adresathree,
                category: data.category,
                description: data.description,
                subcategory: data.subcategory,
                image: data.image,
                year: data.year,
                imdb: data.imdb,
                status: data.status
              })
            }
          })
          this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt })
          this.setCarouselItems()

          var cat_channelstv_jwt = [] 
            this.state.jwtcategory.forEach(data => {
              //alert(data.category);
              if((parseInt(data.id) !== 2) && (parseInt(data.id) !== 4)){
              //  alert(data.category);
              cat_channelstv_jwt.push({
                id: data.id,
                title: data.title,
                description: data.description
              })
            }
          })
          this.setState({ jwtcategory: cat_channelstv_jwt })

          var subcat_channelstv_jwt = [] 
            this.state.jwtsubcategory.forEach(data => {
              //alert(data.category);
              //  alert(data.category);
              subcat_channelstv_jwt.push({
                id: data.id,
                title: data.title,
                description: data.description
              })
          })
          this.setState({ jwtsubcategory: subcat_channelstv_jwt })
          }
        }.bind(this), 400); 
        })
        .catch((error)=>{
          firebase.database().ref("/channelstv_jwt").on('value', snapshot => {
            var channelstv_jwt = []
            var select_options = []
            snapshot.forEach(child => {
              var data = child.val()
              //alert(parseInt(data.category));
                channelstv_jwt.push({
                  id: data.id,
                  denumire: data.denumire,
                  adresa: data.adresa,
                  adresatwo: data.adresatwo,
                  adresathree: data.adresathree,
                  category: data.category,
                  description: data.description,
                  subcategory: data.subcategory,
                  image: data.image,
                  year: data.year,
                  imdb: data.imdb,
                  status: data.status
                })
                select_options.push({
                  value: data.id,
                  label: data.denumire
                })
            this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt, selectoptions: select_options })
            this.setCarouselItems()
          })
        });
        this.setState({
          all_channels: this.state.channels
        });
        setTimeout(function(){ 
          if(this.state.role === '"adminc"'){
            //alert('Adminc');
            //alert(this.state.role);
            var channelstv_jwt = [] 
            this.state.channels.forEach(data => {
              if((parseInt(data.category) !== 2) && (parseInt(data.category) !== 4)){
              channelstv_jwt.push({
                id: data.id,
                denumire: data.denumire,
                adresa: data.adresa,
                adresatwo: data.adresatwo,
                adresathree: data.adresathree,
                category: data.category,
                description: data.description,
                subcategory: data.subcategory,
                image: data.image,
                year: data.year,
                imdb: data.imdb,
                status: data.status
              })
            }
          })
          this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt })
          this.setCarouselItems()
          
          var cat_channelstv_jwt = [] 
            this.state.jwtcategory.forEach(data => {
              //alert(data.category);
              if((parseInt(data.id) !== 2) && (parseInt(data.id) !== 4)){
              //  alert(data.category);
              cat_channelstv_jwt.push({
                id: data.id,
                title: data.title,
                description: data.description
              })
            }
          })
          this.setState({ jwtcategory: cat_channelstv_jwt })

          var subcat_channelstv_jwt = [] 
            this.state.jwtsubcategory.forEach(data => {
              //alert(data.category);
              //  alert(data.category);
              subcat_channelstv_jwt.push({
                id: data.id,
                title: data.title,
                description: data.description
              })
          })
          this.setState({ jwtsubcategory: subcat_channelstv_jwt })
          }
        }.bind(this), 400); 
        console.log(JSON.stringify(error));
      });*/

      //firebase.database().ref("/channelstv_jwt").on('value', snapshot => {
        var i = 0;
        const db = getDatabase();
        var channelstv_jwt = [];
        var select_options = [];
        get(ref(db,"channelstv_jwt")).then((snapshot)=>{
          snapshot.forEach(child => {
            var data = child.val()
            //alert(parseInt(data.category));
            //if(i<50){
              channelstv_jwt.push({
                id: data.id,
                denumire: data.denumire,
                adresa: data.adresa,
                adresatwo: data.adresatwo,
                adresathree: data.adresathree,
                category: data.category,
                description: data.description,
                subcategory: data.subcategory,
                image: data.image,
                year: data.year,
                imdb: data.imdb,
                status: data.status
              })
              select_options.push({
                value: data.id,
                label: data.denumire
              })
            //}
            i++;
        })
      });
      this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt, selectoptions: select_options })
      this.setCarouselItems()
      /*this.setState({
        all_channels: this.state.channels
      });*/
      setTimeout(function(){ 
        if(this.state.role === '"adminc"'){
          //alert('Adminc');
          //alert(this.state.role);
          var channelstv_jwt = [] 
          this.state.channels.forEach(data => {
            if((parseInt(data.category) !== 2) && (parseInt(data.category) !== 4)){
            channelstv_jwt.push({
              id: data.id,
              denumire: data.denumire,
              adresa: data.adresa,
              adresatwo: data.adresatwo,
              adresathree: data.adresathree,
              category: data.category,
              description: data.description,
              subcategory: data.subcategory,
              image: data.image,
              year: data.year,
              imdb: data.imdb,
              status: data.status
            })
          }
        })
        this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt })
        this.setCarouselItems()
        
        var cat_channelstv_jwt = [] 
          this.state.jwtcategory.forEach(data => {
            //alert(data.category);
            if((parseInt(data.id) !== 2) && (parseInt(data.id) !== 4)){
            //  alert(data.category);
            cat_channelstv_jwt.push({
              id: data.id,
              title: data.title,
              description: data.description
            })
          }
        })
        this.setState({ jwtcategory: cat_channelstv_jwt })

        var subcat_channelstv_jwt = [] 
          this.state.jwtsubcategory.forEach(data => {
            //alert(data.category);
            //  alert(data.category);
            subcat_channelstv_jwt.push({
              id: data.id,
              title: data.title,
              description: data.description
            })
        })
        this.setState({ jwtsubcategory: subcat_channelstv_jwt })
        }
      }.bind(this), 700); 

    }

    //componentWillUnmount(){
    //  this.$el.DataTable.destroy(true);
    //}

    logs = () => {
      //alert('Did Logs');
      //firebase.database().ref("/logs").on('value', snapshot => {
        const db = getDatabase();
        get(ref(db,"logs")).then((snapshot)=>{
        var select_logs = []
        snapshot.forEach(child => {
          var data = child.val()
          select_logs.push({
              id: data.id,
              status: data.status,
              message: data.message,
              agent: data.agent,
              ip: data.ip,
              location: data.location,
              user_id: data.user_id,
              time: data.time,
            })
        this.setState({ count_logs: select_logs.length })
        
        })
      })
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((data) => {
          //alert(JSON.stringify(data.ip))
            setTimeout(function(){ 
              this.setState({ myip: data.ip, mylocation: data.country_name+'#'+data.region })
            }.bind(this), 200);
  
      setTimeout(function(){ 
      //alert(JSON.stringify(this.state.count_logs));
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      /*var refdb = firebase.database().ref('/logs').push();
      refdb = refdb.toString().slice(-20);
      
      let updateData = firebase.database().ref("/logs").child(refdb);
      updateData.child("id").set(this.state.count_logs+1);
      updateData.child("status").set('1');
      updateData.child("message").set('User Access TV JWT Page');
      updateData.child("agent").set(navigator.userAgent);
      updateData.child("ip").set(this.state.myip);
      updateData.child("location").set(this.state.mylocation);
      updateData.child("user_id").set(localStorage.getItem('user_id'));
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:this.state.count_logs+1,
            status:'1',
            message:'User Access TV JWT Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
        });
      }.bind(this), 400);
    })

    }

    getUser = () => {
      
      /*firebase.database().ref("/users").orderByChild('email')
      .equalTo(localStorage.getItem('user_id')).on('value', snapshot => {*/
      const db = getDatabase();
      get(query(ref(db, 'users'), orderByChild('email'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
        var userg = []
        snapshot.forEach(child => {
          var data = child.val()
        userg.push({
          id: data.key, 
          email: data.email,
          name: data.name,
          nickname: data.nickname,
          phone: data.phone,
          role: data.role,
          time: data.time
        })
        this.setState({ user: userg })
      })
        
      })
      setTimeout(function(){ 
        this.setState({ role: JSON.stringify(this.state.user[0].role) })
        //alert(JSON.stringify(this.state.role))
      //alert(JSON.stringify(this.state.user[0].role))   
      }.bind(this), 300);   
    }

    tocar = () =>{

      var streamingUrl = document.getElementById('txUrl').value;
  
      //console.log(streamingUrl);
  
      window.jwplayer('mediaspace').setup({
        //'flashplayer': 'jwplayer/jwplayer.flash.swf',       
        //'file': 'rtmp://37.26.69.49:80/live/syri',
        'file': streamingUrl,
        //'file': 'http://192.168.43.1:8080/spydroid.sdp?id=0&h264=500-20-320-240&flash=off&camera=0',
        'autostart': 'true',
        'primary': 'flash',
        'width': '470',
        'height': '320',
        'mediaid': '123456'
      });
      window.jwplayer.key="[HereWouldBeMyKey]";
    }

    setSelectedOption = (val) =>{
      //alert(JSON.stringify(val));
      this.setState({
        playlist: val
      });
      this.state.channels.forEach(data => {
        //alert(data.category);
        if(data.adresa === val){
          this.setState({
            playlist: ((this.state.radioselect==='sursa3')?(data.adresathree):((this.state.radioselect==='sursa2')?(data.adresatwo):(data.adresa)))
          });
        //  alert(data.category);
        this.setState({
          denumireselectie: data.denumire
        });
      }
    })
      setTimeout(function(){
      //alert(this.state.playlist.slice(-21));
      if(this.state.playlist.slice(-17)==='filename=name.mp4'){
        this.setState({
          jwplayer: false,
          videoplayer: true
        });
      }
      if(this.state.playlist.slice(-17)!=='filename=name.mp4'){
        this.setState({
          jwplayer: true,
          videoplayer: false
        });
      }

      if(this.state.playlist.slice(-20)==='filename=adultjw.mp4'){
        this.setState({
          jwplayer: true,
          videoplayer: false
        });
        setTimeout(function(){
          this.setState({
            jwplayer: true
          });
          }.bind(this), 400);
      }
      if(this.state.playlist.slice(-20)!=='filename=adultjw.mp4'){
        this.setState({
          jwplayer: true,
          videoplayer: false
        });
      }
      if(this.state.playlist.slice(-18)==='filename=adult.mp4'){
        //var urllenght=this.state.playlist.length-19;
        //alert(this.state.playlist.slice(0,urllenght));
        //window.jwplayer(this.playerId).setup({
        //  'file': this.state.playlist.slice(0,urllenght),
        //});
        /*
        var agent = navigator.userAgent;
        var isIphone = ((agent.indexOf('iPhone') != -1) || (agent.indexOf('iPod') != -1)) ;

        $videoTag = "";
        if(isIphone()) {
            $videoTag = '<video controls autoplay preload="metadata">';
        } else {
            $videoTag = '<video controls preload="metadata">';
        }
        */
        this.setState({
          jwplayer: false,
          videoadultplayer: true
        });
      }

      if(this.state.playlist.slice(-18)!=='filename=adult.mp4'){
        this.setState({
          jwplayer: true,
          videoadultplayer: false
        });
      }

      if(this.state.playlist.slice(8,26)==='newuniverses.go.ro'){
        this.setState({
          jwplayer: false,
          newuniverseadult_movie: true
        });
      }
      if(this.state.playlist.slice(8,26)!=='newuniverses.go.ro'){
        this.setState({
          jwplayer: true,
          newuniverseadult_movie: false
        });
      }

      if(this.state.playlist.slice(-21)==='filename=avatarul.mp4'){ //15
        this.setState({
          jwplayer: false,
          avatar_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=avatarul.mp4'){
        this.setState({
          jwplayer: true,
          avatar_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=gladiatorul.mp4'){ //15
        this.setState({
          jwplayer: false,
          gladiator_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=gladiatorul.mp4'){
        this.setState({
          jwplayer: true,
          gladiator_movie: false
        });
      }

      if(this.state.playlist.slice(-30)==='filename=independancedayul.mp4'){ //15
        this.setState({
          jwplayer: false,
          independanceday_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=independancedayul.mp4'){
        this.setState({
          jwplayer: true,
          independanceday_movie: false
        });
      }

      if(this.state.playlist.slice(-33)==='filename=starwarssoloastoryul.mp4'){ //15
        this.setState({
          jwplayer: false,
          starwarssoloastory_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=starwarssoloastoryul.mp4'){
        this.setState({
          jwplayer: true,
          starwarssoloastory_movie: false
        });
      }

      if(this.state.playlist.slice(-21)==='filename=intimeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          intime_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=intimeul.mp4'){
        this.setState({
          jwplayer: true,
          intime_movie: false
        });
      }

      if(this.state.playlist.slice(-24)==='filename=bornastarul.mp4'){ //15
        this.setState({
          jwplayer: false,
          bornastar_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=bornastarul.mp4'){
        this.setState({
          jwplayer: true,
          bornastar_movie: false
        });
      }

      if(this.state.playlist.slice(-26)==='filename=prettywomanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          prettywoman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=prettywomanul.mp4'){
        this.setState({
          jwplayer: true,
          prettywoman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=basicinstinctul.mp4'){ //15
        this.setState({
          jwplayer: false,
          basicinstinct_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=basicinstinctul.mp4'){
        this.setState({
          jwplayer: true,
          basicinstinct_movie: false
        });
      }
      
      if(this.state.playlist.slice(-31)==='filename=basicinstincttwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          basicinstincttwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=basicinstincttwoul.mp4'){
        this.setState({
          jwplayer: true,
          basicinstincttwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=doubleimpactul.mp4'){ //15
        this.setState({
          jwplayer: false,
          doubleimpact_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=doubleimpactul.mp4'){
        this.setState({
          jwplayer: true,
          doubleimpact_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=rockyfiveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          rockyfive_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=rockyfiveul.mp4'){
        this.setState({
          jwplayer: true,
          rockyfive_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=thetitanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thetitan_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=thetitanul.mp4'){
        this.setState({
          jwplayer: true,
          thetitan_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=thematrixrevolutionsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thematrixrevolutions_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=thematrixrevolutionsul.mp4'){
        this.setState({
          jwplayer: true,
          thematrixrevolutions_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=thematrixreloadedul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thematrixreloaded_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=thematrixreloadedul.mp4'){
        this.setState({
          jwplayer: true,
          thematrixreloaded_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=frozentwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          frozentwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=frozentwoul.mp4'){
        this.setState({
          jwplayer: true,
          frozentwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=oblivionul.mp4'){ //15
        this.setState({
          jwplayer: false,
          oblivion_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=oblivionul.mp4'){
        this.setState({
          jwplayer: true,
          oblivion_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=spidermanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          spiderman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=spidermanul.mp4'){
        this.setState({
          jwplayer: true,
          spiderman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=spidermantwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          spidermantwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=spidermantwoul.mp4'){
        this.setState({
          jwplayer: true,
          spidermantwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=legionnaireul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          legionnaire_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=legionnaireul.mp4'){
        this.setState({
          jwplayer: true,
          legionnaire_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=agooddaytodiehardul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          agooddaytodiehard_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=agooddaytodiehardul.mp4'){
        this.setState({
          jwplayer: true,
          agooddaytodiehard_movie: false
        });
      }

      if(this.state.playlist.slice(-27)==='filename=thehardcorpsul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          thehardcorps_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=thehardcorpsul.mp4'){
        this.setState({
          jwplayer: true,
          thehardcorps_movie: false
        });
      }

      if(this.state.playlist.slice(-21)==='filename=irobotul.mp4'){ //15
        this.setState({
          jwplayer: false,
          irobot_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=irobotul.mp4'){
        this.setState({
          jwplayer: true,
          irobot_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=robocopthreeul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          robocopthree_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=robocopthreeul.mp4'){
        this.setState({
          jwplayer: true,
          robocopthree_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=robocopul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          robocop_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=robocopul.mp4'){
        this.setState({
          jwplayer: true,
          robocop_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=diehardul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          diehard_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=diehardul.mp4'){
        this.setState({
          jwplayer: true,
          diehard_movie: false
        });
      }

      if(this.state.playlist.slice(-32)==='filename=missionimpossibleul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          missionimpossible_movie: true
        });
        setTimeout(function(){
        this.setState({
          jwplayer: false
        });
        }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=missionimpossibleul.mp4'){
        this.setState({
          jwplayer: true,
          missionimpossible_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=titanicul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          titanic_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=titanicul.mp4'){
        this.setState({
          jwplayer: true,
          titanic_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=shooterul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          shooter_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=shooterul.mp4'){
        this.setState({
          jwplayer: true,
          shooter_movie: false
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }

      if(this.state.playlist.slice(-20)==='filename=troiaul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          troia_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-20)!=='filename=troiaul.mp4'){
        this.setState({
          jwplayer: true,
          troia_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=martianul.mp4'){ //15
        this.setState({
          jwplayer: false,
          martian_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=martianul.mp4'){
        this.setState({
          jwplayer: true,
          martian_movie: false
        });
      }

      if(this.state.playlist.slice(-33)==='filename=thedayaftertomorowul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thedayaftertomorow_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=thedayaftertomorowul.mp4'){
        this.setState({
          jwplayer: true,
          thedayaftertomorow_movie: false
        });
      }

      if(this.state.playlist.slice(-31)==='filename=thorthedarkworldul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thorthedarkworld_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=thorthedarkworldul.mp4'){
        this.setState({
          jwplayer: true,
          thorthedarkworld_movie: false
        });
      }

      if(this.state.playlist.slice(-33)==='filename=douamiidoisprezeceul.mp4'){ //15
        this.setState({
          jwplayer: false,
          douamiidoisprezece_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=douamiidoisprezeceul.mp4'){
        this.setState({
          jwplayer: true,
          douamiidoisprezece_movie: false
        });
      }

      if(this.state.playlist.slice(-25)==='filename=the5thwaveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          the5thwave_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=the5thwaveul.mp4'){
        this.setState({
          jwplayer: true,
          the5thwave_movie: false
        });
      }

      if(this.state.playlist.slice(-23)==='filename=godzillaul.mp4'){ //15
        this.setState({
          jwplayer: false,
          godzilla_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=godzillaul.mp4'){
        this.setState({
          jwplayer: true,
          godzilla_movie: false
        });
      }

      if(this.state.playlist.slice(-23)==='filename=firstmanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          firstman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=firstmanul.mp4'){
        this.setState({
          jwplayer: true,
          firstman_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=ironmanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ironman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=ironmanul.mp4'){
        this.setState({
          jwplayer: true,
          ironman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=grizzlymanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          grizzlyman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=grizzlymanul.mp4'){
        this.setState({
          jwplayer: true,
          grizzlyman_movie: false
        });
      }

      if(this.state.playlist.slice(-23)==='filename=imlegendul.mp4'){ //15
        this.setState({
          jwplayer: false,
          imlegend_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=imlegendul.mp4'){
        this.setState({
          jwplayer: true,
          imlegend_movie: false
        });
      }
      
      if(this.state.playlist.slice(-34)==='filename=thelegendofherculesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thelegendofhercules_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-34)!=='filename=thelegendofherculesul.mp4'){
        this.setState({
          jwplayer: true,
          thelegendofhercules_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=thelegendoftarzanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thelegendoftarzan_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=thelegendoftarzanul.mp4'){
        this.setState({
          jwplayer: true,
          thelegendoftarzan_movie: false
        });
      }

      if(this.state.playlist.slice(-31)==='filename=thelegendofzorroul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thelegendofzorro_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=thelegendofzorroul.mp4'){
        this.setState({
          jwplayer: true,
          thelegendofzorro_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=fistsoflegendul.mp4'){ //15
        this.setState({
          jwplayer: false,
          fistsoflegend_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=fistsoflegendul.mp4'){
        this.setState({
          jwplayer: true,
          fistsoflegend_movie: false
        });
      }

      if(this.state.playlist.slice(-26)==='filename=americansonul.mp4'){ //15
        this.setState({
          jwplayer: false,
          americanson_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=americansonul.mp4'){
        this.setState({
          jwplayer: true,
          americanson_movie: false
        });
      }

      if(this.state.playlist.slice(-26)==='filename=firststrikeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          firststrike_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=firststrikeul.mp4'){
        this.setState({
          jwplayer: true,
          firststrike_movie: false
        });
      }

      if(this.state.playlist.slice(-23)==='filename=anacondaul.mp4'){ //15
        this.setState({
          jwplayer: false,
          anaconda_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=anacondaul.mp4'){
        this.setState({
          jwplayer: true,
          anaconda_movie: false
        });
      }

      if(this.state.playlist.slice(-28)==='filename=anacondathreeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          anacondathree_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=anacondathreeul.mp4'){
        this.setState({
          jwplayer: true,
          anacondathree_movie: false
        });
      }

      if(this.state.playlist.slice(-22)==='filename=theedgeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theedge_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=theedgeul.mp4'){
        this.setState({
          jwplayer: true,
          theedge_movie: false
        });
      }

      if(this.state.playlist.slice(-24)==='filename=countdownul.mp4'){ //15
        this.setState({
          jwplayer: false,
          countdown_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=countdownul.mp4'){
        this.setState({
          jwplayer: true,
          countdown_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=theinvisiblemanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theinvisibleman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=theinvisiblemanul.mp4'){
        this.setState({
          jwplayer: true,
          theinvisibleman_movie: false
        });
      }

      if(this.state.playlist.slice(-24)==='filename=invisibleul.mp4'){ //15
        this.setState({
          jwplayer: false,
          invisible_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=invisibleul.mp4'){
        this.setState({
          jwplayer: true,
          invisible_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=theweathermanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theweatherman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=theweathermanul.mp4'){
        this.setState({
          jwplayer: true,
          theweatherman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=ghostriderul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ghostrider_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=ghostriderul.mp4'){
        this.setState({
          jwplayer: true,
          ghostrider_movie: false
        });
      }

      if(this.state.playlist.slice(-23)==='filename=firefireul.mp4'){ //15
        this.setState({
          jwplayer: false,
          firefire_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=firefireul.mp4'){
        this.setState({
          jwplayer: true,
          firefire_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=cityofangelsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          cityofangels_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=cityofangelsul.mp4'){
        this.setState({
          jwplayer: true,
          cityofangels_movie: false
        });
      }

      if(this.state.playlist.slice(-26)==='filename=constantineul.mp4'){ //15
        this.setState({
          jwplayer: false,
          constantine_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=constantineul.mp4'){
        this.setState({
          jwplayer: true,
          constantine_movie: false
        });
      }

      if(this.state.playlist.slice(-29)==='filename=constantineoldul.mp4'){ //15
        this.setState({
          jwplayer: false,
          constantineold_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=constantineoldul.mp4'){
        this.setState({
          jwplayer: true,
          constantineold_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=stepupul.mp4'){ //15
        this.setState({
          jwplayer: false,
          stepup_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=stepupul.mp4'){
        this.setState({
          jwplayer: true,
          stepup_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=supermanreturnsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          supermanreturns_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=supermanreturnsul.mp4'){
        this.setState({
          jwplayer: true,
          supermanreturns_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=adangerousmanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          adangerousman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=adangerousmanul.mp4'){
        this.setState({
          jwplayer: true,
          adangerousman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=frozenfeverul.mp4'){ //15
        this.setState({
          jwplayer: false,
          frozenfever_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=frozenfeverul.mp4'){
        this.setState({
          jwplayer: true,
          frozenfever_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=coplandul.mp4'){ //15
        this.setState({
          jwplayer: false,
          copland_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=coplandul.mp4'){
        this.setState({
          jwplayer: true,
          copland_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=thefugitiveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thefugitive_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=thefugitiveul.mp4'){
        this.setState({
          jwplayer: true,
          thefugitive_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=looperul.mp4'){ //15
        this.setState({
          jwplayer: false,
          looper_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=looperul.mp4'){
        this.setState({
          jwplayer: true,
          looper_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=greenzoneul.mp4'){ //15
        this.setState({
          jwplayer: false,
          greenzone_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=greenzoneul.mp4'){
        this.setState({
          jwplayer: true,
          greenzone_movie: false
        });
      }
      
      if(this.state.playlist.slice(-39)==='filename=warfortheplanetoftheapesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          warfortheplanetoftheapes_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-39)!=='filename=warfortheplanetoftheapesul.mp4'){
        this.setState({
          jwplayer: true,
          warfortheplanetoftheapes_movie: false
        });
      }
      
      if(this.state.playlist.slice(-37)==='filename=beyondareasonabledoubtul.mp4'){ //15
        this.setState({
          jwplayer: false,
          beyondareasonabledoubt_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-37)!=='filename=beyondareasonabledoubtul.mp4'){
        this.setState({
          jwplayer: true,
          beyondareasonabledoubt_movie: false
        });
      }
      
      if(this.state.playlist.slice(-39)==='filename=riseoftheplanetoftheapesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          riseoftheplanetoftheapes_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-39)!=='filename=riseoftheplanetoftheapesul.mp4'){
        this.setState({
          jwplayer: true,
          riseoftheplanetoftheapes_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=goodkillul.mp4'){ //15
        this.setState({
          jwplayer: false,
          goodkill_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=goodkillul.mp4'){
        this.setState({
          jwplayer: true,
          goodkill_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=thehuntingpartyul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thehuntingparty_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=thehuntingpartyul.mp4'){
        this.setState({
          jwplayer: true,
          thehuntingparty_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=americansniperul.mp4'){ //15
        this.setState({
          jwplayer: false,
          americansniper_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=americansniperul.mp4'){
        this.setState({
          jwplayer: true,
          americansniper_movie: false
        });
      }

      if(this.state.playlist.slice(-23)==='filename=criminalul.mp4'){ //15
        this.setState({
          jwplayer: false,
          criminal_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=criminalul.mp4'){
        this.setState({
          jwplayer: true,
          criminal_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=exodusul.mp4'){ //15
        this.setState({
          jwplayer: false,
          exodus_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=exodusul.mp4'){
        this.setState({
          jwplayer: true,
          exodus_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=startrekintodarknessul.mp4'){ //15
        this.setState({
          jwplayer: false,
          startrekintodarkness_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=startrekintodarknessul.mp4'){
        this.setState({
          jwplayer: true,
          startrekintodarkness_movie: false
        });
      }
      
      if(this.state.playlist.slice(-20)==='filename=kurskul.mp4'){ //15
        this.setState({
          jwplayer: false,
          kursk_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-20)!=='filename=kurskul.mp4'){
        this.setState({
          jwplayer: true,
          kursk_movie: false
        });
      }

      if(this.state.playlist.slice(-18)==='filename=warul.mp4'){ //15
        this.setState({
          jwplayer: false,
          war_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-18)!=='filename=warul.mp4'){
        this.setState({
          jwplayer: true,
          war_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=hartswarul.mp4'){ //15
        this.setState({
          jwplayer: false,
          hartswar_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=hartswarul.mp4'){
        this.setState({
          jwplayer: true,
          hartswar_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=jungleul.mp4'){ //15
        this.setState({
          jwplayer: false,
          jungle_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=jungleul.mp4'){
        this.setState({
          jwplayer: true,
          jungle_movie: false
        });
      }
      
      if(this.state.playlist.slice(-36)==='filename=piratesofthecaribbeanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          piratesofthecaribbean_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-36)!=='filename=piratesofthecaribbeanul.mp4'){
        this.setState({
          jwplayer: true,
          piratesofthecaribbean_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=guardiansofthegalaxyul.mp4'){ //15
        this.setState({
          jwplayer: false,
          guardiansofthegalaxy_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=guardiansofthegalaxyul.mp4'){
        this.setState({
          jwplayer: true,
          guardiansofthegalaxy_movie: false
        });
      }

      if(this.state.playlist.slice(-38)==='filename=guardiansofthegalaxytwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          guardiansofthegalaxytwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-38)!=='filename=guardiansofthegalaxytwoul.mp4'){
        this.setState({
          jwplayer: true,
          guardiansofthegalaxytwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=sniperthreeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          sniperthree_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=sniperthreeul.mp4'){
        this.setState({
          jwplayer: true,
          sniperthree_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=patriotsdayul.mp4'){ //15
        this.setState({
          jwplayer: false,
          patriotsday_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=patriotsdayul.mp4'){
        this.setState({
          jwplayer: true,
          patriotsday_movie: false
        });
      }
      
      if(this.state.playlist.slice(-33)==='filename=motherlessbrooklynul.mp4'){ //15
        this.setState({
          jwplayer: false,
          motherlessbrooklyn_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=motherlessbrooklynul.mp4'){
        this.setState({
          jwplayer: true,
          motherlessbrooklyn_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=terminatorul.mp4'){ //15
        this.setState({
          jwplayer: false,
          terminator_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=terminatorul.mp4'){
        this.setState({
          jwplayer: true,
          terminator_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=firststriketwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          firststriketwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=firststriketwoul.mp4'){
        this.setState({
          jwplayer: true,
          firststriketwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=fortysevenmetersdownul.mp4'){ //15
        this.setState({
          jwplayer: false,
          fortysevenmetersdown_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=fortysevenmetersdownul.mp4'){
        this.setState({
          jwplayer: true,
          fortysevenmetersdown_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=whitehousedownul.mp4'){ //15
        this.setState({
          jwplayer: false,
          whitehousedown_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=whitehousedownul.mp4'){
        this.setState({
          jwplayer: true,
          whitehousedown_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=transformersul.mp4'){ //15
        this.setState({
          jwplayer: false,
          transformers_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=transformersul.mp4'){
        this.setState({
          jwplayer: true,
          transformers_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=stargateul.mp4'){ //15
        this.setState({
          jwplayer: false,
          stargate_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=stargateul.mp4'){
        this.setState({
          jwplayer: true,
          stargate_movie: false
        });
      }
      
      if(this.state.playlist.slice(-19)==='filename=noahul.mp4'){ //15
        this.setState({
          jwplayer: false,
          noah_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-19)!=='filename=noahul.mp4'){
        this.setState({
          jwplayer: true,
          noah_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=oursoulsatnightul.mp4'){ //15
        this.setState({
          jwplayer: false,
          oursoulsatnight_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=oursoulsatnightul.mp4'){
        this.setState({
          jwplayer: true,
          oursoulsatnight_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=transformerstwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          transformerstwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=transformerstwoul.mp4'){
        this.setState({
          jwplayer: true,
          transformerstwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=equalstandardul.mp4'){ //15
        this.setState({
          jwplayer: false,
          equalstandard_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=equalstandardul.mp4'){
        this.setState({
          jwplayer: true,
          equalstandard_movie: false
        });
      }
      
      if(this.state.playlist.slice(-41)==='filename=starwarstheriseofskywalkerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          starwarstheriseofskywalker_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-41)!=='filename=starwarstheriseofskywalkerul.mp4'){
        this.setState({
          jwplayer: true,
          starwarstheriseofskywalker_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=perfectsenseul.mp4'){ //15
        this.setState({
          jwplayer: false,
          perfectsense_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=perfectsenseul.mp4'){
        this.setState({
          jwplayer: true,
          perfectsense_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=regardinghenryul.mp4'){ //15
        this.setState({
          jwplayer: false,
          regardinghenry_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=regardinghenryul.mp4'){
        this.setState({
          jwplayer: true,
          regardinghenry_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=theimmigrantul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theimmigrant_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=theimmigrantul.mp4'){
        this.setState({
          jwplayer: true,
          theimmigrant_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=themazerunnerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          themazerunner_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=themazerunnerul.mp4'){
        this.setState({
          jwplayer: true,
          themazerunner_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=pointbreakul.mp4'){ //15
        this.setState({
          jwplayer: false,
          pointbreak_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=pointbreakul.mp4'){
        this.setState({
          jwplayer: true,
          pointbreak_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=threehundredul.mp4'){ //15
        this.setState({
          jwplayer: false,
          threehundred_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=threehundredul.mp4'){
        this.setState({
          jwplayer: true,
          threehundred_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=dunkirkul.mp4'){ //15
        this.setState({
          jwplayer: false,
          dunkirk_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=dunkirkul.mp4'){
        this.setState({
          jwplayer: true,
          dunkirk_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=threehundredtwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          threehundredtwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=threehundredtwoul.mp4'){
        this.setState({
          jwplayer: true,
          threehundredtwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=insurgentul.mp4'){ //15
        this.setState({
          jwplayer: false,
          insurgent_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=insurgentul.mp4'){
        this.setState({
          jwplayer: true,
          insurgent_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=extinctionul.mp4'){ //15
        this.setState({
          jwplayer: false,
          extinction_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=extinctionul.mp4'){
        this.setState({
          jwplayer: true,
          extinction_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=thecoreul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thecore_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=thecoreul.mp4'){
        this.setState({
          jwplayer: true,
          thecore_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=sevenyearsintibetul.mp4'){ //15
        this.setState({
          jwplayer: false,
          sevenyearsintibet_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=sevenyearsintibetul.mp4'){
        this.setState({
          jwplayer: true,
          sevenyearsintibet_movie: false
        });
      }
      
      if(this.state.playlist.slice(-31)==='filename=universalsoldierul.mp4'){ //15
        this.setState({
          jwplayer: false,
          universalsoldier_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=universalsoldierul.mp4'){
        this.setState({
          jwplayer: true,
          universalsoldier_movie: false
        });
      }

      if(this.state.playlist.slice(-32)==='filename=partyharddieyoungul.mp4'){ //15
        this.setState({
          jwplayer: false,
          partyharddieyoung_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=partyharddieyoungul.mp4'){
        this.setState({
          jwplayer: true,
          partyharddieyoung_movie: false
        });
      }
      
      if(this.state.playlist.slice(-31)==='filename=behindenemylinesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          behindenemylines_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=behindenemylinesul.mp4'){
        this.setState({
          jwplayer: true,
          behindenemylines_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=alienoverlordsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          alienoverlords_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=alienoverlordsul.mp4'){
        this.setState({
          jwplayer: true,
          alienoverlords_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=themummyul.mp4'){ //15
        this.setState({
          jwplayer: false,
          themummy_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=themummyul.mp4'){
        this.setState({
          jwplayer: true,
          themummy_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=burnoutul.mp4'){ //15
        this.setState({
          jwplayer: false,
          burnout_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=burnoutul.mp4'){
        this.setState({
          jwplayer: true,
          burnout_movie: false
        });
      }
      
      if(this.state.playlist.slice(-19)==='filename=darcul.mp4'){ //15
        this.setState({
          jwplayer: false,
          darc_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-19)!=='filename=darcul.mp4'){
        this.setState({
          jwplayer: true,
          darc_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=elysiumul.mp4'){ //15
        this.setState({
          jwplayer: false,
          elysium_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=elysiumul.mp4'){
        this.setState({
          jwplayer: true,
          elysium_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=xmentwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          xmentwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=xmentwoul.mp4'){
        this.setState({
          jwplayer: true,
          xmentwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=icemanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          iceman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=icemanul.mp4'){
        this.setState({
          jwplayer: true,
          iceman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=drailedul.mp4'){ //15
        this.setState({
          jwplayer: false,
          drailed_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=drailedul.mp4'){
        this.setState({
          jwplayer: true,
          drailed_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=thecorruptedul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thecorrupted_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=thecorruptedul.mp4'){
        this.setState({
          jwplayer: true,
          thecorrupted_movie: false
        });
      }
      
      if(this.state.playlist.slice(-42)==='filename=aravindasamethaveeraraghavaul.mp4'){ //15
        this.setState({
          jwplayer: false,
          aravindasamethaveeraraghava_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-42)!=='filename=aravindasamethaveeraraghavaul.mp4'){
        this.setState({
          jwplayer: true,
          aravindasamethaveeraraghava_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=thewheelul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thewheel_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=thewheelul.mp4'){
        this.setState({
          jwplayer: true,
          thewheel_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=theoutsiderul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theoutsider_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=theoutsiderul.mp4'){
        this.setState({
          jwplayer: true,
          theoutsider_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=interrogationul.mp4'){ //15
        this.setState({
          jwplayer: false,
          interrogation_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=interrogationul.mp4'){
        this.setState({
          jwplayer: true,
          interrogation_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=momentumul.mp4'){ //15
        this.setState({
          jwplayer: false,
          momentum_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=momentumul.mp4'){
        this.setState({
          jwplayer: true,
          momentum_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=thecutlassul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thecutlass_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=thecutlassul.mp4'){
        this.setState({
          jwplayer: true,
          thecutlass_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=secretintheireyesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          secretintheireyes_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=secretintheireyesul.mp4'){
        this.setState({
          jwplayer: true,
          secretintheireyes_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=frompariswithloveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          frompariswithlove_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=frompariswithloveul.mp4'){
        this.setState({
          jwplayer: true,
          frompariswithlove_movie: false
        });
      }
      
      if(this.state.playlist.slice(-34)==='filename=insidemanmostwantedul.mp4'){ //15
        this.setState({
          jwplayer: false,
          insidemanmostwanted_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-34)!=='filename=insidemanmostwantedul.mp4'){
        this.setState({
          jwplayer: true,
          insidemanmostwanted_movie: false
        });
      }
      
      if(this.state.playlist.slice(-32)==='filename=goyotheboygeneralul.mp4'){ //15
        this.setState({
          jwplayer: false,
          goyotheboygeneral_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-32)!=='filename=goyotheboygeneralul.mp4'){
        this.setState({
          jwplayer: true,
          goyotheboygeneral_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=thecurrentwarul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thecurrentwar_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=thecurrentwarul.mp4'){
        this.setState({
          jwplayer: true,
          thecurrentwar_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=xmendaysoffuturepastul.mp4'){ //15
        this.setState({
          jwplayer: false,
          xmendaysoffuturepast_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=xmendaysoffuturepastul.mp4'){
        this.setState({
          jwplayer: true,
          xmendaysoffuturepast_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=allegiantul.mp4'){ //15
        this.setState({
          jwplayer: false,
          allegiant_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=allegiantul.mp4'){
        this.setState({
          jwplayer: true,
          allegiant_movie: false
        });
      }
      
      if(this.state.playlist.slice(-19)==='filename=ichiul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ichi_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-19)!=='filename=ichiul.mp4'){
        this.setState({
          jwplayer: true,
          ichi_movie: false
        });
      }
      
      if(this.state.playlist.slice(-33)==='filename=avpalienvspredatorul.mp4'){ //15
        this.setState({
          jwplayer: false,
          avpalienvspredator_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=avpalienvspredatorul.mp4'){
        this.setState({
          jwplayer: true,
          avpalienvspredator_movie: false
        });
      }
      
      if(this.state.playlist.slice(-33)==='filename=kingdomofheavenul.mp4'){ //15
        this.setState({
          jwplayer: false,
          kingdomofheaven_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=kingdomofheavenul.mp4'){
        this.setState({
          jwplayer: true,
          kingdomofheaven_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=ghostsofwarul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ghostsofwar_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=ghostsofwarul.mp4'){
        this.setState({
          jwplayer: true,
          ghostsofwar_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=theplatformul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theplatform_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=theplatformul.mp4'){
        this.setState({
          jwplayer: true,
          theplatform_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=battlescarsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          battlescars_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=battlescarsul.mp4'){
        this.setState({
          jwplayer: true,
          battlescars_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=bloodandgloryul.mp4'){ //15
        this.setState({
          jwplayer: false,
          bloodandglory_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=bloodandgloryul.mp4'){
        this.setState({
          jwplayer: true,
          bloodandglory_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=bloodfatherul.mp4'){ //15
        this.setState({
          jwplayer: false,
          bloodfather_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=bloodfatherul.mp4'){
        this.setState({
          jwplayer: true,
          bloodfather_movie: false
        });
      }
      
      if(this.state.playlist.slice(-47)==='filename=hoursthesecretsoldiersofbenghaziul.mp4'){ //15
        this.setState({
          jwplayer: false,
          hoursthesecretsoldiersofbenghazi_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-47)!=='filename=hoursthesecretsoldiersofbenghaziul.mp4'){
        this.setState({
          jwplayer: true,
          hoursthesecretsoldiersofbenghazi_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=thefinesthoursul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thefinesthours_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=thefinesthoursul.mp4'){
        this.setState({
          jwplayer: true,
          thefinesthours_movie: false
        });
      }
      
      if(this.state.playlist.slice(-18)==='filename=auxul.mp4'){ //15
        this.setState({
          jwplayer: false,
          aux_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-18)!=='filename=auxul.mp4'){
        this.setState({
          jwplayer: true,
          aux_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=ayogyaul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ayogya_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=ayogyaul.mp4'){
        this.setState({
          jwplayer: true,
          ayogya_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=thedirectiveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thedirective_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=thedirectiveul.mp4'){
        this.setState({
          jwplayer: true,
          thedirective_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=elchicanoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          elchicano_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=elchicanoul.mp4'){
        this.setState({
          jwplayer: true,
          elchicano_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=mymotherul.mp4'){ //15
        this.setState({
          jwplayer: false,
          mymother_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=mymotherul.mp4'){
        this.setState({
          jwplayer: true,
          mymother_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=firstloveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          firstlove_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=firstloveul.mp4'){
        this.setState({
          jwplayer: true,
          firstlove_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=drinkslayloveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          drinkslaylove_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=drinkslayloveul.mp4'){
        this.setState({
          jwplayer: true,
          drinkslaylove_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=thewholetruthul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thewholetruth_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=thewholetruthul.mp4'){
        this.setState({
          jwplayer: true,
          thewholetruth_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=ashesinthesnowul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ashesinthesnow_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=ashesinthesnowul.mp4'){
        this.setState({
          jwplayer: true,
          ashesinthesnow_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=capsuleul.mp4'){ //15
        this.setState({
          jwplayer: false,
          capsule_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=capsuleul.mp4'){
        this.setState({
          jwplayer: true,
          capsule_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=paloaltoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          paloalto_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=paloaltoul.mp4'){
        this.setState({
          jwplayer: true,
          paloalto_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=moffieul.mp4'){ //15
        this.setState({
          jwplayer: false,
          moffie_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=moffieul.mp4'){
        this.setState({
          jwplayer: true,
          moffie_movie: false
        });
      }
      
      if(this.state.playlist.slice(-34)==='filename=thebeastinthejungleul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thebeastinthejungle_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-34)!=='filename=thebeastinthejungleul.mp4'){
        this.setState({
          jwplayer: true,
          thebeastinthejungle_movie: false
        });
      }
      
      if(this.state.playlist.slice(-33)==='filename=thebirdcatcherssonul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thebirdcatchersson_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=thebirdcatcherssonul.mp4'){
        this.setState({
          jwplayer: true,
          thebirdcatchersson_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=bharatul.mp4'){ //15
        this.setState({
          jwplayer: false,
          bharat_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=bharatul.mp4'){
        this.setState({
          jwplayer: true,
          bharat_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=thewolvesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thewolves_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=thewolvesul.mp4'){
        this.setState({
          jwplayer: true,
          thewolves_movie: false
        });
      }
      
      if(this.state.playlist.slice(-36)==='filename=godblessthebrokenroadul.mp4'){ //15
        this.setState({
          jwplayer: false,
          godblessthebrokenroad_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-36)!=='filename=godblessthebrokenroadul.mp4'){
        this.setState({
          jwplayer: true,
          godblessthebrokenroad_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=thespacewalkerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thespacewalker_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=thespacewalkerul.mp4'){
        this.setState({
          jwplayer: true,
          thespacewalker_movie: false
        });
      }
      
      if(this.state.playlist.slice(-42)==='filename=justiceleaguevsthefatalfiveul.mp4'){ //15
        this.setState({
          jwplayer: false,
          justiceleaguevsthefatalfive_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-42)!=='filename=justiceleaguevsthefatalfiveul.mp4'){
        this.setState({
          jwplayer: true,
          justiceleaguevsthefatalfive_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=xmenapocalypseul.mp4'){ //15
        this.setState({
          jwplayer: false,
          xmenapocalypse_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=xmenapocalypseul.mp4'){
        this.setState({
          jwplayer: true,
          xmenapocalypse_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=earthandbloodul.mp4'){ //15
        this.setState({
          jwplayer: false,
          earthandblood_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=earthandbloodul.mp4'){
        this.setState({
          jwplayer: true,
          earthandblood_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=theshallowsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theshallows_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=theshallowsul.mp4'){
        this.setState({
          jwplayer: true,
          theshallows_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=thehuntressruneofthedeadul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thehuntressruneofthedead_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=thehuntressruneofthedeadul.mp4'){
        this.setState({
          jwplayer: true,
          thehuntressruneofthedead_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=highlifeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          highlife_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=highlifeul.mp4'){
        this.setState({
          jwplayer: true,
          highlife_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=parasiteul.mp4'){ //15
        this.setState({
          jwplayer: false,
          parasite_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=parasiteul.mp4'){
        this.setState({
          jwplayer: true,
          parasite_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=crucibleofthevampireul.mp4'){ //15
        this.setState({
          jwplayer: false,
          crucibleofthevampire_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=crucibleofthevampireul.mp4'){
        this.setState({
          jwplayer: true,
          crucibleofthevampire_movie: false
        });
      }
      
      if(this.state.playlist.slice(-19)==='filename=jinnul.mp4'){ //15
        this.setState({
          jwplayer: false,
          jinn_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-19)!=='filename=jinnul.mp4'){
        this.setState({
          jwplayer: true,
          jinn_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=angelhasfallenul.mp4'){ //15
        this.setState({
          jwplayer: false,
          angelhasfallen_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=angelhasfallenul.mp4'){
        this.setState({
          jwplayer: true,
          angelhasfallen_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=aroughdraftul.mp4'){ //15
        this.setState({
          jwplayer: false,
          aroughdraft_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=aroughdraftul.mp4'){
        this.setState({
          jwplayer: true,
          aroughdraft_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=coldgroundul.mp4'){ //15
        this.setState({
          jwplayer: false,
          coldground_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=coldgroundul.mp4'){
        this.setState({
          jwplayer: true,
          coldground_movie: false
        });
      }
      
      if(this.state.playlist.slice(-20)==='filename=mandyul.mp4'){ //15
        this.setState({
          jwplayer: false,
          mandy_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-20)!=='filename=mandyul.mp4'){
        this.setState({
          jwplayer: true,
          mandy_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=draculauntoldul.mp4'){ //15
        this.setState({
          jwplayer: false,
          draculauntold_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=draculauntoldul.mp4'){
        this.setState({
          jwplayer: true,
          draculauntold_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=widowswalkul.mp4'){ //15
        this.setState({
          jwplayer: false,
          widowswalk_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=widowswalkul.mp4'){
        this.setState({
          jwplayer: true,
          widowswalk_movie: false
        });
      }
      
      if(this.state.playlist.slice(-17)==='filename=usul.mp4'){ //15
        this.setState({
          jwplayer: false,
          us_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-17)!=='filename=usul.mp4'){
        this.setState({
          jwplayer: true,
          us_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=therevenantul.mp4'){ //15
        this.setState({
          jwplayer: false,
          therevenant_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=therevenantul.mp4'){
        this.setState({
          jwplayer: true,
          therevenant_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=thedarktowerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thedarktower_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=thedarktowerul.mp4'){
        this.setState({
          jwplayer: true,
          thedarktower_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=apocalyptoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          apocalypto_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=apocalyptoul.mp4'){
        this.setState({
          jwplayer: true,
          apocalypto_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=replaceul.mp4'){ //15
        this.setState({
          jwplayer: false,
          replace_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=replaceul.mp4'){
        this.setState({
          jwplayer: true,
          replace_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=alienimplantul.mp4'){ //15
        this.setState({
          jwplayer: false,
          alienimplant_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=alienimplantul.mp4'){
        this.setState({
          jwplayer: true,
          alienimplant_movie: false
        });
      }
      
      if(this.state.playlist.slice(-28)==='filename=fantasticfourul.mp4'){ //15
        this.setState({
          jwplayer: false,
          fantasticfour_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-28)!=='filename=fantasticfourul.mp4'){
        this.setState({
          jwplayer: true,
          fantasticfour_movie: false
        });
      }
      
      if(this.state.playlist.slice(-31)==='filename=fantasticfourtwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          fantasticfourtwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=fantasticfourtwoul.mp4'){
        this.setState({
          jwplayer: true,
          fantasticfourtwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=herculesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          hercules_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=herculesul.mp4'){
        this.setState({
          jwplayer: true,
          hercules_movie: false
        });
      }
      
      if(this.state.playlist.slice(-34)==='filename=gijoetheriseofcobraul.mp4'){ //15
        this.setState({
          jwplayer: false,
          gijoetheriseofcobra_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-34)!=='filename=gijoetheriseofcobraul.mp4'){
        this.setState({
          jwplayer: true,
          gijoetheriseofcobra_movie: false
        });
      }
      
      if(this.state.playlist.slice(-37)==='filename=captainamericacivilwarul.mp4'){ //15
        this.setState({
          jwplayer: false,
          captainamericacivilwar_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-37)!=='filename=captainamericacivilwarul.mp4'){
        this.setState({
          jwplayer: true,
          captainamericacivilwar_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=minotaurul.mp4'){ //15
        this.setState({
          jwplayer: false,
          minotaur_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=minotaurul.mp4'){
        this.setState({
          jwplayer: true,
          minotaur_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=krampusoriginsul.mp4'){ //15
        this.setState({
          jwplayer: false,
          krampusorigins_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=krampusoriginsul.mp4'){
        this.setState({
          jwplayer: true,
          krampusorigins_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=behindyouul.mp4'){ //15
        this.setState({
          jwplayer: false,
          behindyou_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=behindyouul.mp4'){
        this.setState({
          jwplayer: true,
          behindyou_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=theunbornul.mp4'){ //15
        this.setState({
          jwplayer: false,
          theunborn_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=theunbornul.mp4'){
        this.setState({
          jwplayer: true,
          theunborn_movie: false
        });
      }
      
      if(this.state.playlist.slice(-39)==='filename=flightsixhundredsixtysixul.mp4'){ //15
        this.setState({
          jwplayer: false,
          flightsixhundredsixtysix_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-39)!=='filename=flightsixhundredsixtysixul.mp4'){
        this.setState({
          jwplayer: true,
          flightsixhundredsixtysix_movie: false
        });
      }
      
      if(this.state.playlist.slice(-42)==='filename=prideandprejudiceandzombiesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          prideandprejudiceandzombies_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-42)!=='filename=prideandprejudiceandzombiesul.mp4'){
        this.setState({
          jwplayer: true,
          prideandprejudiceandzombies_movie: false
        });
      }
      
      if(this.state.playlist.slice(-31)==='filename=loveinwinterlandul.mp4'){ //15
        this.setState({
          jwplayer: false,
          loveinwinterland_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-31)!=='filename=loveinwinterlandul.mp4'){
        this.setState({
          jwplayer: true,
          loveinwinterland_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=wintercastleul.mp4'){ //15
        this.setState({
          jwplayer: false,
          wintercastle_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=wintercastleul.mp4'){
        this.setState({
          jwplayer: true,
          wintercastle_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=memoirsofageishaul.mp4'){ //15
        this.setState({
          jwplayer: false,
          memoirsofageisha_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=memoirsofageishaul.mp4'){
        this.setState({
          jwplayer: true,
          memoirsofageisha_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=sonofsaulul.mp4'){ //15
        this.setState({
          jwplayer: false,
          sonofsaul_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=sonofsaulul.mp4'){
        this.setState({
          jwplayer: true,
          sonofsaul_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=thedoubleul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thedouble_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=thedoubleul.mp4'){
        this.setState({
          jwplayer: true,
          thedouble_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=sgtwillgardnerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          sgtwillgardner_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=sgtwillgardnerul.mp4'){
        this.setState({
          jwplayer: true,
          sgtwillgardner_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=wherehandstouchul.mp4'){ //15
        this.setState({
          jwplayer: false,
          wherehandstouch_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=wherehandstouchul.mp4'){
        this.setState({
          jwplayer: true,
          wherehandstouch_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=zombiesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          zombies_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=zombiesul.mp4'){
        this.setState({
          jwplayer: true,
          zombies_movie: false
        });
      }
      
      if(this.state.playlist.slice(-29)==='filename=alienvszombiesul.mp4'){ //15
        this.setState({
          jwplayer: false,
          alienvszombies_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-29)!=='filename=alienvszombiesul.mp4'){
        this.setState({
          jwplayer: true,
          alienvszombies_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=erniejoeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          erniejoe_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=erniejoeul.mp4'){
        this.setState({
          jwplayer: true,
          erniejoe_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=painandgloryul.mp4'){ //15
        this.setState({
          jwplayer: false,
          painandglory_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=painandgloryul.mp4'){
        this.setState({
          jwplayer: true,
          painandglory_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=afantasticwomanul.mp4'){ //15
        this.setState({
          jwplayer: false,
          afantasticwoman_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=afantasticwomanul.mp4'){
        this.setState({
          jwplayer: true,
          afantasticwoman_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=stormboyul.mp4'){ //15
        this.setState({
          jwplayer: false,
          stormboy_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=stormboyul.mp4'){
        this.setState({
          jwplayer: true,
          stormboy_movie: false
        });
      }
      
      if(this.state.playlist.slice(-22)==='filename=thecrowul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thecrow_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-22)!=='filename=thecrowul.mp4'){
        this.setState({
          jwplayer: true,
          thecrow_movie: false
        });
      }
      
      if(this.state.playlist.slice(-33)==='filename=momentumgenerationul.mp4'){ //15
        this.setState({
          jwplayer: false,
          momentumgeneration_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-33)!=='filename=momentumgenerationul.mp4'){
        this.setState({
          jwplayer: true,
          momentumgeneration_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=thesecretdaretodreamul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thesecretdaretodream_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=thesecretdaretodreamul.mp4'){
        this.setState({
          jwplayer: true,
          thesecretdaretodream_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=ifyouaregoneul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ifyouaregone_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=ifyouaregoneul.mp4'){
        this.setState({
          jwplayer: true,
          ifyouaregone_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=hunterkillerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          hunterkiller_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=hunterkillerul.mp4'){
        this.setState({
          jwplayer: true,
          hunterkiller_movie: false
        });
      }
      
      if(this.state.playlist.slice(-30)==='filename=ghostintheshellul.mp4'){ //15
        this.setState({
          jwplayer: false,
          ghostintheshell_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-30)!=='filename=ghostintheshellul.mp4'){
        this.setState({
          jwplayer: true,
          ghostintheshell_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=replicasul.mp4'){ //15
        this.setState({
          jwplayer: false,
          replicas_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=replicasul.mp4'){
        this.setState({
          jwplayer: true,
          replicas_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=beetlejuiceul.mp4'){ //15
        this.setState({
          jwplayer: false,
          beetlejuice_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=beetlejuiceul.mp4'){
        this.setState({
          jwplayer: true,
          beetlejuice_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=monsterhouseul.mp4'){ //15
        this.setState({
          jwplayer: false,
          monsterhouse_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=monsterhouseul.mp4'){
        this.setState({
          jwplayer: true,
          monsterhouse_movie: false
        });
      }
      
      if(this.state.playlist.slice(-21)==='filename=carrieul.mp4'){ //15
        this.setState({
          jwplayer: false,
          carrie_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-21)!=='filename=carrieul.mp4'){
        this.setState({
          jwplayer: true,
          carrie_movie: false
        });
      }
      
      if(this.state.playlist.slice(-26)==='filename=corpsebrideul.mp4'){ //15
        this.setState({
          jwplayer: false,
          corpsebride_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-26)!=='filename=corpsebrideul.mp4'){
        this.setState({
          jwplayer: true,
          corpsebride_movie: false
        });
      }
      
      if(this.state.playlist.slice(-24)==='filename=halloweenul.mp4'){ //15
        this.setState({
          jwplayer: false,
          halloween_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=halloweenul.mp4'){
        this.setState({
          jwplayer: true,
          halloween_movie: false
        });
      }

      if(this.state.playlist.slice(-17)==='filename=itul.mp4'){ //15
        this.setState({
          jwplayer: false,
          it_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-17)!=='filename=itul.mp4'){
        this.setState({
          jwplayer: true,
          it_movie: false
        });
      }
      
      if(this.state.playlist.slice(-45)==='filename=transformersrevengeofthefallenul.mp4'){ //15
        this.setState({
          jwplayer: false,
          transformersrevengeofthefallen_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-45)!=='filename=transformersrevengeofthefallenul.mp4'){
        this.setState({
          jwplayer: true,
          transformersrevengeofthefallen_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=itchaptertwoul.mp4'){ //15
        this.setState({
          jwplayer: false,
          itchaptertwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=itchaptertwoul.mp4'){
        this.setState({
          jwplayer: true,
          itchaptertwo_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=poseidonul.mp4'){ //15
        this.setState({
          jwplayer: false,
          poseidon_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=poseidonul.mp4'){
        this.setState({
          jwplayer: true,
          poseidon_movie: false
        });
      }
      
      if(this.state.playlist.slice(-23)==='filename=timetrapul.mp4'){ //15
        this.setState({
          jwplayer: false,
          timetrap_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-23)!=='filename=timetrapul.mp4'){
        this.setState({
          jwplayer: true,
          timetrap_movie: false
        });
      }
      
      if(this.state.playlist.slice(-36)==='filename=thecloverfieldparadoxul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thecloverfieldparadox_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-36)!=='filename=thecloverfieldparadoxul.mp4'){
        this.setState({
          jwplayer: true,
          thecloverfieldparadox_movie: false
        });
      }
      
      if(this.state.playlist.slice(-35)==='filename=thetimetravelerswifeul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thetimetravelerswife_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-35)!=='filename=thetimetravelerswifeul.mp4'){
        this.setState({
          jwplayer: true,
          thetimetravelerswife_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=thegatewayul.mp4'){ //15
        this.setState({
          jwplayer: false,
          thegateway_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=thegatewayul.mp4'){
        this.setState({
          jwplayer: true,
          thegateway_movie: false
        });
      }
      
      if(this.state.playlist.slice(-27)==='filename=projectpowerul.mp4'){ //15
        this.setState({
          jwplayer: false,
          projectpower_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-27)!=='filename=projectpowerul.mp4'){
        this.setState({
          jwplayer: true,
          projectpower_movie: false
        });
      }
      
      if(this.state.playlist.slice(-46)==='filename=nightatthemuseumsecretofthetombul.mp4'){ //15
        this.setState({
          jwplayer: false,
          nightatthemuseumsecretofthetomb_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-46)!=='filename=nightatthemuseumsecretofthetombul.mp4'){
        this.setState({
          jwplayer: true,
          nightatthemuseumsecretofthetomb_movie: false
        });
      }
      
      if(this.state.playlist.slice(-25)==='filename=passengersul.mp4'){ //15
        this.setState({
          jwplayer: false,
          passengers_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-25)!=='filename=passengersul.mp4'){
        this.setState({
          jwplayer: true,
          passengers_movie: false
        });
      }
      
      if(this.state.playlist.slice(-20)==='filename=venomul.mp4'){ //15
        this.setState({
          jwplayer: false,
          venom_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-20)!=='filename=venomul.mp4'){
        this.setState({
          jwplayer: true,
          venom_movie: false
        });
      }
      
      if(this.state.playlist.slice(-19)==='filename=lucyul.mp4'){ //15
        this.setState({
          jwplayer: false,
          lucy_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-19)!=='filename=lucyul.mp4'){
        this.setState({
          jwplayer: true,
          lucy_movie: false
        });
      }
      
      if(this.state.playlist.slice(-20)==='filename=alphaul.mp4'){ //15
        this.setState({
          jwplayer: false,
          alpha_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-20)!=='filename=alphaul.mp4'){
        this.setState({
          jwplayer: true,
          alpha_movie: false
        });
      }

      if(this.state.playlist.slice(-24)==='filename=avatartwoul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          avatartwo_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-24)!=='filename=avatartwoul.mp4'){
        this.setState({
          jwplayer: true,
          avatartwo_movie: false
        });
      }

      if(this.state.playlist.slice(-20)==='filename=atlasul.mp4'){ //15 
        this.setState({
          jwplayer: false,
          atlas_movie: true
        });
        setTimeout(function(){
          this.setState({
            jwplayer: false
          });
          }.bind(this), 200);
      }
      if(this.state.playlist.slice(-20)!=='filename=atlasul.mp4'){
        this.setState({
          jwplayer: true,
          atlas_movie: false
        });
      }

      //console.log(this.state.jwplayer);
      if(this.state.playlist.slice(8,20)!=='diskoteka.ro'){
      setTimeout(function(){
        this.setState({
          jwplayer: true
        });
        }.bind(this), 100);
      }

      this.state.all_channels.forEach(data => {

      if(data.adresa === this.state.playlist){
        this.setState({
          rezumat: data.description
        });
        //alert(data.description);
      }
    })
    }.bind(this), 500);
    }

    setSelectedOptionjwtcategory = (val) =>{
      this.setState({
        jwtcategories: val
      });
      setTimeout(function(){
     //alert(JSON.stringify(val));
     //alert(JSON.stringify(this.state.all_channels));
     var channelstv_jwt = [] 
      this.state.all_channels.forEach(data => {
        if(data.category === val){
        channelstv_jwt.push({
          id: data.id,
          denumire: data.denumire,
          adresa: data.adresa,
          adresatwo: data.adresatwo,
          adresathree: data.adresathree,
          category: data.category,
          description: data.description,
          subcategory: data.subcategory,
          image: data.image,
          year: data.year,
          imdb: data.imdb,
          status: data.status
        })
      }
    })
    if(parseInt(val) === 0){
      channelstv_jwt = this.state.all_channels
    }
    this.setState({ channels: channelstv_jwt })
    this.setCarouselItems()
    }.bind(this), 300);
    }

    setCategory_jwt_category = () =>{
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");

      //firebase.database().ref("/channels_jwt_category").remove()
      const db = getDatabase();
      remove(ref(db,"channels_jwt_category"));
      this.state.jwtcategory.forEach(child => {
      /*var refdb = firebase.database().ref('/channels_jwt_category').push();
      refdb = refdb.toString().slice(-20);
      let updateData = firebase.database().ref("/channels_jwt_category").child(refdb);
      updateData.child("id").set(child.id);
      updateData.child("title").set(child.title);
      updateData.child("description").set(child.description);
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/channels_jwt_category'));
      set(refdb,{
        id:child.id,
        title:child.title,
        description:child.description,
        time:curtime
      });
      });
    }

    setCategory_jwt_subcategory = () =>{
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");

      //firebase.database().ref("/channels_jwt_subcategory").remove()
      const db = getDatabase();
      remove(ref(db,"channels_jwt_subcategory"));

      this.state.jwtsubcategory.forEach(child => {
      /*var refdb = firebase.database().ref('/channels_jwt_subcategory').push();
      refdb = refdb.toString().slice(-20);
      let updateData = firebase.database().ref("/channels_jwt_subcategory").child(refdb);
      updateData.child("id").set(child.id);
      updateData.child("title").set(child.title);
      updateData.child("description").set(child.description);
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/channels_jwt_subcategory'));
      set(refdb,{
        id:child.id,
        title:child.title,
        description:child.description,
        time:curtime
      });
      });
    }

    setCarouselItems = () =>{
      setTimeout(function(){ 
      var i=0;
      var j=0;
      var carouselitemss=[];
      var carouselitemssub=[];
      this.state.channels.forEach(data => {
        carouselitemssub.splice(j,0, {
          id: data.id,
          denumire: data.denumire,
          adresa: data.adresa,
          adresatwo: data.adresatwo,
          adresathree: data.adresathree,
          category: data.category,
          description: data.description,
          subcategory: data.subcategory,
          image: data.image,
          year: data.year,
          imdb: data.imdb,
          status: data.status
        })
        
        j=j+1;
        if(j===4){
          carouselitemss.splice(i,0,{carouselitemssub});
          carouselitemssub=[];
          i=i+1;
          j=0;
        }
        this.setState({
          carouselitems: carouselitemss
        });
      })
      //setTimeout(function(){ 
      //  console.log(JSON.stringify(this.state.carouselitems));
      //}.bind(this), 200);
      }.bind(this), 1200);
    }

    selectChange = (val) =>{
      //alert(JSON.stringify(val));
      //alert(JSON.stringify(this.state.selectoptions));
      //alert(val.value);
      this.state.channels.forEach(function(data) {
        if(data.id === val.value){
          this.setState({
            playlist: ((this.state.radioselect==='sursa3')?(data.adresathree):((this.state.radioselect==='sursa2')?(data.adresatwo):(data.adresa)))
          });
        }
      }.bind(this))
    }

    carouselselectchannel = (val) =>{
      //alert(JSON.stringify(val));
      this.setState({
        playlist: val,
      });
      this.state.channels.forEach(data => {
        //alert(data.category);
        if(data.adresa === val){
        //  alert(data.category);
        this.setState({
          playlist: ((this.state.radioselect==='sursa3')?(data.adresathree):((this.state.radioselect==='sursa2')?(data.adresatwo):(data.adresa)))
        });
        this.setState({
          denumireselectie: data.denumire
        });
      }
    })
      this.setSelectedOption(val);

      setTimeout(function(){ 
      this.state.channels.forEach(data => {
        if(data.adresa === this.state.playlist){
          this.setState({
            rezumat: data.description
          });
        }
      });
      }.bind(this), 200);
    }

    setradio = (e) =>{
      //alert("Radio"+JSON.stringify(e.target.value));
      this.setState({
        radiocheckedone: (e.target.value==='sursa1')?(true):(false),
        radiocheckedtwo: (e.target.value==='sursa2')?(true):(false),
        radiocheckedthree: (e.target.value==='sursa3')?(true):(false),
        radiocheckedfour: (e.target.value==='sursa4')?(true):(false),
        radioselect: (e.target.value==='sursa3')?('sursa4'):((e.target.value==='sursa3')?('sursa3'):((e.target.value==='sursa2')?('sursa2'):('sursa1'))),
      });
      this.state.channels.forEach(function(data) {
        if(data.adresa === this.state.playlist && (e.target.value==='sursa1')){
          let videoplayer = document.getElementById('my-video-stream');
          videoplayer.style.display='block';
          this.setState({
            videojsshow:false
          });
          this.setState({
            playlist: data.adresa,
          });
          this.setSelectedOption(data.adresa);
        }
        if(data.adresa === this.state.playlist && (e.target.value==='sursa2')){
          let videoplayer = document.getElementById('my-video-stream');
          videoplayer.style.display='block';
          this.setState({
            videojsshow:false
          });
          this.setState({
            playlist: data.adresatwo,
          });
          this.setSelectedOption(data.adresatwo);
          if(data.adresa.slice(-21)==='filename=avatarul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'avatar');
            formData.append('year', '2009');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            //url = 'https://s-delivery30.mxdcontent.net/d/o7jmn1k6ilexz7/8bty3ih1tg3ofqfk?ab=0&r=https%3A%2F%2Fmixdrop.co%2Ff%2F%2F'+res.result.fileref;
           //console.log(url);
           //localStorage.setItem("url",url);
           // console.log(res);
              //setTimeout(()=>{
                this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=avatarul.mp4');
              //}, 300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-24)==='filename=gladiatorul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'gladiator');
            formData.append('year', '2000');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=gladiatorul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-21)==='filename=looperul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'looper');
            formData.append('year', '2012');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=looperul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-23)==='filename=thetitanul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'thetitan');
            formData.append('year', '2018');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=thetitanul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-22)==='filename=titanicul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'titanic');
            formData.append('year', '1997');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=titanicul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-25)==='filename=passengersul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'passengers');
            formData.append('year', '2016');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=passengersul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-21)==='filename=intimeul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'intime');
            formData.append('year', '2011');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=intimeul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-21)==='filename=irobotul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'irobot');
            formData.append('year', '2004');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=irobotul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-30)==='filename=independancedayul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'independanceday');
            formData.append('year', '2016');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=independancedayul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-31)==='filename=basicinstincttwoul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'basicinstincttwo');
            formData.append('year', '2006');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=basicinstincttwoul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-28)==='filename=basicinstinctul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'basicinstinct');
            formData.append('year', '1992');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=basicinstinctul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-20)==='filename=troiaul.mp4'){ //15 
            let formData = new FormData();
            formData.append('movie', 'troia');
            formData.append('year', '2004');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=troiaul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-23)==='filename=oblivionul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'oblivion');
            formData.append('year', '2013');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=oblivionul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-22)==='filename=martianul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'martian');
            formData.append('year', '2015');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=martianul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-23)==='filename=replicasul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'replicas');
            formData.append('year', '2018');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=replicasul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-20)==='filename=venomul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'venom');
            formData.append('year', '2018');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=venomul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-24)==='filename=avatartwoul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'avatartwo');
            formData.append('year', '2022');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption('https://bileteacum.ro/apitickets/phphttptohttps/index_mp4.php?url="'+res.data.movie+'"&filename=avatartwoul.mp4');
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
        }
        if(data.adresa === this.state.playlist && (e.target.value==='sursa3')){
          let videoplayer = document.getElementById('my-video-stream');
          videoplayer.style.display='block';
          this.setState({
            videojsshow:false
          });
          if(data.adresa.slice(-21)==='filename=avatarul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'avatar');
            formData.append('year', '2009');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
            //url = 'https://s-delivery30.mxdcontent.net/d/o7jmn1k6ilexz7/8bty3ih1tg3ofqfk?ab=0&r=https%3A%2F%2Fmixdrop.co%2Ff%2F%2F'+res.result.fileref;
           //console.log(url);
           //localStorage.setItem("url",url);
           // console.log(res);
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-24)==='filename=gladiatorul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'gladiator');
            formData.append('year', '2000');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-21)==='filename=looperul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'looper');
            formData.append('year', '2012');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-23)==='filename=thetitanul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'thetitan');
            formData.append('year', '2018');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-22)==='filename=titanicul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'titanic');
            formData.append('year', '1997');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-25)==='filename=passengersul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'passengers');
            formData.append('year', '2016');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-21)==='filename=intimeul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'intime');
            formData.append('year', '2011');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-21)==='filename=irobotul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'irobot');
            formData.append('year', '2004');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-30)==='filename=independancedayul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'independanceday');
            formData.append('year', '2016');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-31)==='filename=basicinstincttwoul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'basicinstincttwo');
            formData.append('year', '2006');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(data.adresa.slice(-28)==='filename=basicinstinctul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'basicinstinct');
            formData.append('year', '1992');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-20)==='filename=troiaul.mp4'){ //15 
            let formData = new FormData();
            formData.append('movie', 'troia');
            formData.append('year', '2004');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-23)==='filename=oblivionul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'oblivion');
            formData.append('year', '2013');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-22)==='filename=martianul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'martian');
            formData.append('year', '2015');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-23)==='filename=replicasul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'replicas');
            formData.append('year', '2018');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-20)==='filename=venomul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'venom');
            formData.append('year', '2018');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
          })
          .then(res=>res.json())
          .then((res)=>{
           this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          if(this.state.playlist.slice(-24)==='filename=avatartwoul.mp4'){ //15
            let formData = new FormData();
            formData.append('movie', 'avatartwo');
            formData.append('year', '2022');
            fetch('https://lost-ways.com/slim/api/movies',{
              method: 'POST',
              body: formData
            })
            .then(res=>res.json())
            .then((res)=>{
              this.setSelectedOption(res.data.movie);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

        }
        if(data.adresa === this.state.playlist && (e.target.value==='sursa4')){
          if(data.adresa.slice(-21)==='filename=avatarul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/3', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/Avatar_2009_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }
          
          if(data.adresa.slice(-24)==='filename=gladiatorul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/2', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
               tracks: [{
                 kind: 'subtitles',
                 src: "assets/sub/Gladiator_2000_sub_ro.vtt",
                 srcLang: 'ro',
                 label: 'Romanian',
                 default: true
               }],
             },
             videojsshow: true,
             jwplayer: false,
             videoplayer: false,
           });
           setTimeout(()=>{
               this.setState({
                 videoplayer: false,
               });
           },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(data.adresa.slice(-21)==='filename=intimeul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/1', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/InTime_2011_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(data.adresa.slice(-25)==='filename=passengersul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/4', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/Passengers_2016_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(this.state.playlist.slice(-20)==='filename=troiaul.mp4'){ //15 
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/6', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
               tracks: [{
                 kind: 'subtitles',
                 src: "assets/sub/Troia_2004_sub_ro.vtt",
                 srcLang: 'ro',
                 label: 'Romanian',
                 default: true
               }],
             },
             videojsshow: true,
             jwplayer: false,
             videoplayer: false,
           });
           setTimeout(()=>{
               this.setState({
                 videoplayer: false,
               });
           },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(this.state.playlist.slice(-22)==='filename=martianul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/8', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/Martian_2015_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(data.adresa.slice(-21)==='filename=irobotul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/9', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/IRobot_2004_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(data.adresa.slice(-23)==='filename=thetitanul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/5', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/TheTitan_2018_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(this.state.playlist.slice(-23)==='filename=oblivionul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/7', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/Oblivion_2013_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
            //this.setSelectedOption(localStorage.getItem("url"));
          }

          if(this.state.playlist.slice(-24)==='filename=avatartwoul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/10', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/Avatartwo_2022_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
          }

          if(this.state.playlist.slice(-20)==='filename=atlasul.mp4'){ //15
            const credentials = {
              username: 'meserie',
              password: '1qaz2wsx'
            };
            fetch('https://py-movies.wasmer.app/api/auth/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(credentials)
            })
            .then(res => res.json())
            .then((res) => {
              if (!res.access_token) {
                throw new Error('Login failed: no access token');
              }
              const token = res.access_token;
              localStorage.setItem('token', token);
              return fetch('https://py-movies.wasmer.app/api/movies/11', {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
            })
            .then(res => res.json())
            .then((res)=>{
           //this.setSelectedOption(res.data.movie);
              let videoplayer = document.getElementById('my-video-stream');
              videoplayer.style.display='none';
              this.setState({
                videoJsOptions:{
                  autoplay: true,
                  controls: true,
                  responsive: true,
                  fluid: true,
                  sources: [{
                    src: res.download_url,
                    type: 'video/mp4'
                  }],
                  tracks: [{
                    kind: 'subtitles',
                    src: "assets/sub/Atlas_2024_sub_ro.vtt",
                    srcLang: 'ro',
                    label: 'Romanian',
                    default: true
                  }],
                },
                videojsshow: true,
                jwplayer: false,
                videoplayer: false,
              });
              setTimeout(()=>{
                  this.setState({
                    videoplayer: false,
                  });
              },300);
            });
          }
        }
      }.bind(this))
      
    }

    AddChannel = (e) =>{
      e.preventDefault();
      const db = getDatabase();
      var refdb = push(ref(db,'/channelstv_jwt'));
      set(refdb,{
        id: this.state.all_channels.length+1,
        adresa: 'https://diskoteka.ro/apitickets/phphttptohttps/index_mp4.php?url=""&filename=newmovieul.mp4',
        adresatwo: 'https://diskoteka.ro/apitickets/phphttptohttps/index_mp4.php?url=""&filename=newmovieul.mp4',
        adresathree: 'https://diskoteka.ro/apitickets/phphttptohttps/index_mp4.php?url=""&filename=newmovieul.mp4',
        category: "3",
        denumire: "newmovie",
        description: "newmovie",
        image: "https://vasileclaudiu.github.io/reactsopcast/assets/images/carouseljwt/NewMovie.jpg",
        status: "enable",
        subcategory: "0",
        year: "2023"
      });
    }

    render(){
      const carouselindicatorsl={
        backgroundColor: 'red',
        width: '20px',
        margin: '0 0 0 -30px'
      }
      const carouselindicatorsr={
        backgroundColor: 'red',
        width: '20px',
        margin: '0 -30px 0 0'
      }
      const carouselindicatorslin={
        backgroundColor: 'red',
        width: '20px',
      }
      const carouselindicatorsrin={
        backgroundColor: 'red',
        width: '20px',
      }
      const carouseldivimg={
        display: 'inline-block',
        marginLeft: '-4px',
        cursor: 'pointer',
        minHeight: '200px',
        height: 'auto',
      }
      const carouselimg={
        width: '100%',
        height: 'auto',
        display: 'inline-block',
        marginLeft: '-4px'
      }
      const displaynone={
        display: 'none'
      }
      const { carouselitems, currentPage, itemsPerPage,upperPageBound,lowerPageBound,isPrevBtnActive,isNextBtnActive } = this.state;
      // Logic for displaying current todos
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = carouselitems.slice(indexOfFirstItem, indexOfLastItem);
      //console.log(currentItems);
      //currentItems.shift();
      //for (let i = 0; i < (parseInt(itemsPerPage)-2); i++) {
      //  currentItems.pop();
      //}
      //currentItems.shift();
      const renderItems = currentItems.map((item, index) => {
        return (parseInt(index)===0)?(<div className="container carousel-inner no-padding" style={nopadding} key={index}>
        {currentItems.map((channel, index) => (
        <div className={(index===0)?("carousel-item active"):("carousel-item")} key={index}>
          {channel.carouselitemssub.map((item, i) => (
              <div className="col-xs-3 col-sm-3 col-md-3" style={carouseldivimg}  onClick={(() => this.carouselselectchannel(item.adresa))} key={i}>
                <img style={carouselimg} src={item.image} title={item.denumire+' - '+item.description}></img>
                <p>Date: {item.year}</p>{(item.category==='3')?(<p>IMDB: {item.imdb}</p>):(<p></p>)}
              </div>
          ))}  
        </div>
        ))}
      </div>):'';
      });

      // Logic for displaying page numbers
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(carouselitems.length / itemsPerPage); i++) {
        pageNumbers.push(i);
      }
      //console.log(Math.ceil(currentItems.length / itemsPerPage));
      const renderPageNumbers = pageNumbers.map(number => {
          if(number === 1 && currentPage === 1){
              return(
                  <li key={number} className='active' id={number}><button id={number} onClick={((e) => this.handleClick(e))} className={(this.state.currentPage===number)?("btn btn-primary active"):("btn btn-primary")}>{number}</button></li>
              )
          }
          else if((number < upperPageBound + 1) && number > lowerPageBound){
              return(
                  <li key={number} id={number}><button id={number} onClick={((e) => this.handleClick(e))} className={(this.state.currentPage===number)?("btn btn-primary active"):("btn btn-primary")}>{number}</button></li>
              )
          }
      });
      let pageIncrementBtn = null;
      if(pageNumbers.length > upperPageBound){
          pageIncrementBtn = <li className=''><button onClick={((e) => this.btnIncrementClick(e))} className="btn btn-primary"> &hellip; </button></li>
      }
      let pageDecrementBtn = null;
      if(lowerPageBound >= 1){
          pageDecrementBtn = <li className=''><button onClick={((e) => this.btnDecrementClick(e))} className="btn btn-primary"> &hellip; </button></li>
      }
      let renderPrevBtn = null;
      if(isPrevBtnActive === 'disabled') {
          renderPrevBtn = <li className={isPrevBtnActive}><span id="btnPrev" className="btn btn-warning disabled" > Prev </span></li>
      }
      else{
          renderPrevBtn = <li className={isPrevBtnActive}><button id="btnPrev" onClick={((e) => this.btnPrevClick(e))} className="btn btn-primary"> Prev </button></li>
      }
      let renderNextBtn = null;
      if(isNextBtnActive === 'disabled') {
          renderNextBtn = <li className={isNextBtnActive}><span id="btnNext" className="btn btn-warning disabled" > Next </span></li>
      }
      else{
          renderNextBtn = <li className={isNextBtnActive}><button id="btnNext" onClick={((e) => this.btnNextClick(e))} className="btn btn-primary"> Next </button></li>
      }
          const divStyless={  
            height:'150px',
            position:'relative',
            marginBottom: '350px'
          };
          const divStylesssp={
            position:'relative',
            marginBottom: '250px',
            diplay:'flex'
          };
          const videoplayerstyle={
            marginBottom: '20px',
            width: '590px'
          };
          const selecttwostyle={
            marginRight: '20px',
            width: this.state.role==='"admin"'?'250px':'150px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
          }
          const canalestyle={
            top: '25%',
            transform: 'translateY(25%)',
            verticalAlign: 'center',
            padding: '0 0 0 20px',
          }
          const rezumatstyle={
            display: 'inline-block',
          }
          const lasthrstyle={
            display: 'inline-block',
            position: 'relative',
            padding: '100px 0 100px 0',
          }
          const nopadding={
            paddingLeft: '0',
            paddingRight: '0'
          }
         
          const divradiobutons={
            zIndex: '100'
          }
        return (
            <main role="main" className="col-md-9 ml-sm-auto col-lg-10 pt-3 px-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
              <h1 className="h2">Dashboard TVJW Page</h1>
            </div>
            <p>Dashboard TVJW Page</p>

          <div id="demo" className="carousel slide" data-ride="carousel">
              <ul className="carousel-indicators">
                <li data-target="#demo" data-slide-to="0" className="active"></li>
                <li data-target="#demo" data-slide-to="1"></li>
                <li data-target="#demo" data-slide-to="2"></li>
              </ul>
              {renderItems}
              <a className="carousel-control-prev" href="#demo" data-slide="prev" style={carouselindicatorsl}>
                <span className="carousel-control-prev-icon" style={carouselindicatorslin}></span>
              </a>
              <a className="carousel-control-next" href="#demo" data-slide="next" style={carouselindicatorsr}>
                <span className="carousel-control-next-icon" style={carouselindicatorsrin}></span>
              </a>
          </div>

            <ul className="pagination">
              {renderPrevBtn}
              {pageDecrementBtn}
              {renderPageNumbers}
              {pageIncrementBtn}
              {renderNextBtn}
            </ul>

            <div style={divStyless}>
            <div className="row">
            <div className="float-left" style={canalestyle}>Count Channels: <strong>{this.state.channels.length}</strong></div>
            <div className="ml-auto" style={selecttwostyle}>
              {this.state.role=='"admin"'&&(<button className='btn btn-primary' onClick={((e) => this.AddChannel(e))}>Add</button>)}
            <Select
              className="select2 w-100"
              name="form-field-name"
              value="Select Channels"
              options={this.state.selectoptions}
              onChange={this.selectChange}
            />
            </div>
            </div>
            {this.atlas_movie !== true && this.avatartwo_movie !== true && this.alpha_movie !== true && this.lucy_movie !== true && this.venom_movie !== true && this.passengers_movie !== true && this.nightatthemuseumsecretofthetomb_movie !== true && this.projectpower_movie !== true && this.thegateway_movie !== true && this.thetimetravelerswife_movie !== true && this.thecloverfieldparadox_movie !== true && this.timetrap_movie !== true && this.poseidon_movie !== true && this.itchaptertwo_movie !== true && this.transformersrevengeofthefallen_movie !== true && this.it_movie !== true && this.halloween_movie !== true && this.monsterhouse_movie !== true && this.beetlejuice_movie !== true && this.replicas_movie !== true && this.ghostintheshell_movie !== true && this.hunterkiller_movie !== true && this.ifyouaregone_movie !== true && this.thesecretdaretodream_movie !== true && this.momentumgeneration_movie !== true && this.thecrow_movie !== true && this.stormboy_movie !== true && this.afantasticwoman_movie !== true && this.painandglory_movie !== true && this.erniejoe_movie !== true && this.alienvszombies_movie !== true && this.zombies_movie !== true && this.wherehandstouch_movie !== true && this.sgtwillgardner_movie !== true && this.thedouble_movie !== true && this.sonofsaul_movie !== true && this.memoirsofageisha_movie !== true && this.wintercastle_movie !== true && this.loveinwinterland_movie !== true && this.prideandprejudiceandzombies_movie !== true && this.flightsixhundredsixtysix_movie !== true && this.theunborn_movie !== true && this.behindyou_movie !== true && this.krampusorigins_movie !== true && this.minotaur_movie !== true && this.captainamericacivilwar_movie !== true && this.gijoetheriseofcobra_movie !== true && this.hercules_movie !== true && this.fantasticfourtwo_movie !== true && this.fantasticfour_movie !== true && this.alienimplant_movie !== true && this.replace_movie !== true && this.apocalypto_movie !== true && this.thedarktower_movie !== true && this.therevenant_movie !== true && this.us_movie !== true && this.widowswalk_movie !== true && this.draculauntold_movie !== true && this.mandy_movie !== true && this.coldground_movie !== true && this.aroughdraft_movie !== true && this.angelhasfallen_movie !== true && this.jinn_movie !== true && this.crucibleofthevampire_movie !== true && this.parasite_movie !== true && this.highlife_movie !== true && this.thehuntressruneofthedead_movie !== true && this.theshallows_movie !== true && this.earthandblood_movie !== true && this.xmenapocalypse_movie !== true && this.justiceleaguevsthefatalfive_movie !== true && this.thespacewalker_movie !== true && this.godblessthebrokenroad_movie !== true && this.thewolves_movie !== true && this.bharat_movie !== true && this.thebirdcatchersson_movie !== true && this.thebeastinthejungle_movie !== true && this.moffie_movie !== true && this.paloalto_movie !== true && this.capsule_movie !== true && this.ashesinthesnow_movie !== true && this.thewholetruth_movie !== true && this.drinkslaylove_movie !== true && this.firstlove_movie !== true && this.mymother_movie !== true && this.elchicano_movie !== true && this.thedirective_movie !== true && this.ayogya_movie !== true && this.aux_movie !== true && this.thefinesthours_movie !== true && this.hoursthesecretsoldiersofbenghazi_movie !== true && this.bloodfather_movie !== true && this.bloodandglory_movie !== true && this.battlescars_movie !== true && this.theplatform_movie !== true && this.ghostsofwar_movie !== true && this.kingdomofheaven_movie !== true && this.avpalienvspredator_movie !== true && this.ichi_movie !== true && this.allegiant_movie !== true && this.xmendaysoffuturepast_movie !== true && this.thecurrentwar_movie !== true && this.goyotheboygeneral_movie !== true && this.insidemanmostwanted_movie !== true && this.frompariswithlove_movie !== true && this.secretintheireyes_movie !== true && this.thecutlass_movie !== true && this.momentum_movie !== true && this.interrogation_movie !== true && this.theoutsider_movie !== true && this.thewheel_movie !== true && this.aravindasamethaveeraraghava_movie !== true && this.destroyer_movie !== true && this.thecorrupted_movie !== true && this.drailed_movie !== true && this.iceman_movie !== true && this.xmentwo_movie !== true && this.elysium_movie !== true && this.darc_movie !== true && this.burnout_movie !== true && this.themummy_movie !== true && this.alienoverlords_movie !== true && this.behindenemylines_movie !== true && this.partyharddieyoung_movie !== true && this.universalsoldier_movie !== true && this.sevenyearsintibet_movie !== true && this.thecore_movie !== true && this.extinction_movie !== true && this.insurgent_movie !== true && this.threehundredtwo_movie !== true && this.dunkirk_movie !== true && this.threehundred_movie !== true && this.pointbreak_movie !== true && this.themazerunner_movie !== true && this.theimmigrant_movie !== true && this.regardinghenry_movie !== true && this.perfectsense_movie !== true && this.starwarstheriseofskywalker_movie !== true && this.equalstandard_movie !== true && this.transformerstwo_movie !== true && this.oursoulsatnight_movie !== true && this.noah_movie !== true && this.stargate_movie !== true && this.transformers_movie !== true && this.whitehousedown_movie !== true && this.fortysevenmetersdown_movie !== true && this.firststriketwo_movie !== true && this.terminator_movie !== true && this.motherlessbrooklyn_movie !== true && this.patriotsday_movie !== true && this.sniperthree_movie !== true && this.guardiansofthegalaxytwo_movie !== true && this.guardiansofthegalaxy_movie !== true && this.piratesofthecaribbean_movie !== true && this.jungle_movie !== true && this.hartswar_movie !== true && this.war_movie !== true && this.kursk_movie !== true && this.startrekintodarkness_movie !== true && this.exodus_movie !== true && this.criminal_movie !== true && this.americansniper_movie !== true && this.thehuntingparty_movie !== true && this.goodkill_movie !== true && this.riseoftheplanetoftheapes_movie !== true && this.beyondareasonabledoubt_movie !== true && this.warfortheplanetoftheapes_movie !== true && this.greenzone_movie !== true && this.looper_movie !== true && this.thefugitive_movie !== true && this.copland_movie !== true && this.frozenfever_movie !== true && this.adangerousman_movie !== true && this.supermanreturns_movie !== true && this.stepup_movie !== true && this.constantineold_movie !== true && this.constantine_movie !== true && this.cityofangels_movie !== true && this.firefire_movie !== true && this.ghostrider_movie !== true && this.theweatherman_movie !== true && this.invisible_movie !== true && this.theinvisibleman_movie !== true && this.augustfalls_movie !== true && this.countdown_movie !== true && this.thedge_movie !== true && this.anacondathree_movie !== true && this.anaconda_movie !== true && this.firststrike_movie !== true && this.americanson_movie !== true && this.fistsoflegend_movie !== true && this.thelegendofzorro_movie !== true && this.thelegendoftarzan_movie !== true && this.thelegendofhercules_movie !== true && this.imlegend_movie !== true && this.grizzlyman_movie !== true && this.ironman_movie !== true && this.firstman_movie !== true && this.godzilla_movie !== true && this.the5thwave_movie !== true && this.douamiidoisprezece_movie !== true && this.thorthedarkworld_movie !== true && this.thedayaftertomorow_movie !== true && this.martian_movie !== true && this.troia_movie !== true && this.shooter_movie !== true && this.titanic_movie !== true && this.missionimpossible_movie !== true && this.diehard_movie !== true && this.robocop_movie !== true && this.robocopthree_movie !== true && this.irobot_movie !== true && this.thehardcorps_movie !== true && this.agooddaytodiehard_movie !== true && this.legionnaire_movie !== true && this.spidermantwo_movie !== true && this.spiderman_movie !== true && this.oblivion_movie !== true && this.frozentwo_movie !== true && this.thematrixreloaded_movie !== true && this.thematrixrevolutions_movie !== true && this.state.thetitan_movie !== true && this.state.rockyfive_movie !== true && this.state.doubleimpact_movie !== true && this.state.basicinstincttwo_movie !== true && this.state.basicinstinct_movie !== true && this.state.prettywoman_movie !== true && this.state.bornastar_movie !== true && this.state.intime_movie !== true && this.state.starwarssoloastory_movie !== true && this.state.newuniverseadult_movie !== true && this.state.independanceday_movie !== true && this.state.gladiator_movie !== true && this.state.avatar_movie !== true && this.state.jwplayer === true && (<ReactJWPlayer
              playlist={[{
              file: this.state.playlist,
              tracks: [{
                file: this.state.playlist.slice(-10)==='avatar.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Avatar_2009_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='gladiator.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Gladiator_2000_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='independanceday.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/IndependenceDay_1996_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='starwarssoloastory.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/StarWarsSoloAStory_2018_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='intime.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/InTime_2011_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='bornastar.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BornAStar_2018_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='prettywoman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PrettyWoman_1990_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='basicinstinct.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BasicInstinct_1992_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='basicinstincttwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BasicInstinctTwo_2006_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='doubleimpact.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/DoubleImpact_1991_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='rockyfive.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/RockyFive_1990_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='thetitan.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheTitan_2018_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='thematrixrevolutions.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheMatrixRevolutions_2003_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='thematrixreloaded.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheMatrixReloaded_2003_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='frozentwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FrozenTwo_2019_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='oblivion.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Oblivion_2013_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='spiderman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Spiderman_2002_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='spidermantwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Spidermantwo_2004_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='legionnaire.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Legionnaire_1998_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='agooddaytodiehard.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AGoodDaytoDieHard_2013_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='thehardcorps.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheHardCorps_2006_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='irobot.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/IRobot_2004_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='robocopthree.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/RoboCopThree_1993_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='robocop.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/RoboCop_2014_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='diehard.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/DieHard_1988_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='missionimpossible.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/MissionImpossible_2018_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='titanic.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Titanic_1997_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='shooter.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Shooter_2007_sub_ro.vtt':
                (this.state.playlist.slice(-9)==='troia.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Troia_2004_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='martian.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Martian_2015_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='thedayaftertomorow.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheDayAfterTomorow_2004_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='thorthedarkworld.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ThorTheDarkWorld_2013_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='douamiidoisprezece.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/DouaMiiDoisprezece_2012_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='the5thwave.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/The5thWave_2016_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='godzilla.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Godzilla_2014_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='firstman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FirstMan_2018_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='ironman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/IronMan_2008_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='grizzlyman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GrizzlyMan_2005_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='imlegend.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ImLegend_2007_sub_ro.vtt':
                (this.state.playlist.slice(-23)==='thelegendofhercules.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheLegendOfHercules_2014_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='thelegendoftarzan.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheLegendOfTarzan_2016_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='thelegendofzorro.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheLegendOfZorro_2005_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='fistsoflegend.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FistsOfLegend_2013_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='americanson.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AmericanSon_2019_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='firststrike.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FirstStrike_1996_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='anaconda.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Anaconda_1997_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='anacondathree.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AnacondaThree_2008_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='theedge.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheEdge_1998_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='countdown.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/CountDown_2016_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='theinvisibleman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheInvisibleMan_2020_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='invisible.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Invisible_2017_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='theweatherman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheWeatherMan_2005_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='ghostrider.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GhostRider_2011_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='firefire.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FireFire_2012_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='cityofangels.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/CityOfAngels_1998_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='constantine.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Constantine_2018_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='constantineold.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Constantine_2005_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='stepup.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/StepUp_2019_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='supermanreturns.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/SupermanReturns_2006_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='adangerousman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ADangerousMan_2009_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='frozenfever.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FrozenFever_2015_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='copland.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/CopLand_1997_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='thefugitive.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheFugitive_1993_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='looper.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Looper_2012_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='greenzone.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GreenZone_2010_sub_ro.vtt':
                (this.state.playlist.slice(-28)==='warfortheplanetoftheapes.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/WarForThePlanetOfTheApes_2017_sub_ro.vtt':
                (this.state.playlist.slice(-26)==='beyondareasonabledoubt.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BeyondAReasonableDoubt_2009_sub_ro.vtt':
                (this.state.playlist.slice(-28)==='riseoftheplanetoftheapes.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/RiseOfThePlanetOfTheApes_2011_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='goodkill.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GoodKill_2014_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='americansniper.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AmericanSniper_2014_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='criminal.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Criminal_2016_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='exodus.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Exodus_2014_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='startrekintodarkness.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/StarTrekIntoDarkness_2013_sub_ro.vtt':
                (this.state.playlist.slice(-9)==='kursk.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Kursk_2018_sub_ro.vtt':
                (this.state.playlist.slice(-7)==='war.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/War_2007_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='hartswar.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/HartsWar_2002_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='jungle.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Jungle_2017_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='piratesofthecaribbean.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PiratesOfTheCaribbean_2011_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='guardiansofthegalaxy.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GuardiansOfTheGalaxy_2014_sub_ro.vtt':
                (this.state.playlist.slice(-27)==='guardiansofthegalaxytwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GuardiansOfTheGalaxyTwo_2017_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='sniperthree.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/SniperThree_2004_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='patriotsday.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PatriotsDay_2016_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='motherlessbrooklyn.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/MotherlessBrooklyn_2019_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='terminator.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Terminator_2019_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='firststriketwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FirstStrikeTwo_2016_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='fortysevenmetersdown.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FortySevenMetersDown_2017_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='whitehousedown.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/WhiteHouseDown_2013_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='transformers.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Transformers_2007_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='stargate.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Stargate_2008_sub_ro.vtt':
                (this.state.playlist.slice(-8)==='noah.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Noah_2014_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='oursoulsatnight.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/OurSoulsAtNight_2017_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='transformerstwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TransformersTwo_2017_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='equalstandard.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/EqualStandard_2020_sub_ro.vtt':
                (this.state.playlist.slice(-30)==='starwarstheriseofskywalker.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/StarWarsTheRiseOfSkywalker_2019_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='perfectsense.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PerfectSense_2011_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='regardinghenry.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/RegardingHenry_1991_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='theimmigrant.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheImmigrant_2013_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='themazerunner.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheMazeRunner_2014_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='pointbreak.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PointBreak_1991_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='threehundred.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ThreeHundred_2007_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='dunkirk.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Dunkirk_2017_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='threehundredtwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ThreeHundredTwo_2014_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='insurgent.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Insurgent_2015_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='extinction.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Extinction_2018_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='thecore.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheCore_2003_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='sevenyearsintibet.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/SevenYearsInTibet_1997_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='universalsoldier.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/UniversalSoldier_2009_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='partyharddieyoung.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PartyHardDieYoung_2018_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='behindenemylines.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BehindEnemyLines_2001_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='alienoverlords.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AlienOverlords_2018_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='themummy.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheMummy_2017_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='burnout.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BurnOut_2017_sub_ro.vtt':
                (this.state.playlist.slice(-8)==='darc.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Darc_2018_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='elysium.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Elysium_2013_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='xmentwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/XMenTwo_2003_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='iceman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Iceman_2014_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='drailed.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/DRailed_2018_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='thecorrupted.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheCorrupted_2019_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='destroyer.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Destroyer_2018_sub_ro.vtt':
                (this.state.playlist.slice(-31)==='aravindasamethaveeraraghava.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AravindaSamethaVeeraRaghava_2018_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='thewheel.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheWheel_2019_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='theoutsider.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheOutsider_2018_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='interrogation.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Interrogation_2016_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='momentum.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Momentum_2015_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='thecutlass.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheCutlass_2017_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='secretintheireyes.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/SecretInTheirEyes_2015_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='frompariswithlove.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FromParisWithLove_2010_sub_ro.vtt':
                (this.state.playlist.slice(-23)==='insidemanmostwanted.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/InsideManMostWanted_2019_sub_ro.vtt':
                (this.state.playlist.slice(-21)==='goyotheboygeneral.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GoyoTheBoyGeneral_2018_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='thecurrentwar.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheCurrentWar_2019_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='xmendaysoffuturepast.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/XMenDaysOfFuturePast_2014_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='allegiant.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Allegiant_2016_sub_ro.vtt':
                (this.state.playlist.slice(-8)==='ichi.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Ichi_2008_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='avpalienvspredator.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AvpAlienVsPredator_2004_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='kingdomofheaven.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/KingdomOfHeaven_2005_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='ghostsofwar.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GhostsOfWar_2020_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='theplatform.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ThePlatform_2019_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='battlescars.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BattleScars_2020_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='bloodandglory.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BloodAndGlory_2016_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='bloodfather.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BloodFather_2016_sub_ro.vtt':
                (this.state.playlist.slice(-36)==='hoursthesecretsoldiersofbenghazi.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/HoursTheSecretSoldiersOfBenghazi_2016_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='thefinesthours.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheFinestHours_2016_sub_ro.vtt':
                (this.state.playlist.slice(-7)==='aux.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Aux_2018_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='ayogya.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Ayogya_2019_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='thedirective.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheDirective_2019_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='elchicano.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ElChicano_2019_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='mymother.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/MyMother_2015_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='firstlove.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FirstLove_2019_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='drinkslaylove.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/DrinkSlayLove_2017_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='thewholetruth.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheWholeTruth_2016_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='ashesinthesnow.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AshesInTheSnow_2018_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='capsule.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Capsule_2015_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='paloalto.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PaloAlto_2014_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='moffie.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Moffie_2019_sub_ro.vtt':
                (this.state.playlist.slice(-23)==='thebeastinthejungle.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheBeastInTheJungle_2019_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='thebirdcatchersson.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheBirdcatchersSon_2019_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='bharat.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Bharat_2019_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='thewolves.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheWolves_2020_sub_ro.vtt':
                (this.state.playlist.slice(-25)==='godblessthebrokenroad.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GodBlessTheBrokenRoad_2018_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='thespacewalker.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheSpacewalker_2017_sub_ro.vtt':
                (this.state.playlist.slice(-31)==='justiceleaguevsthefatalfive.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/JusticeLeagueVsTheFatalFive_2019_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='xmenapocalypse.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/XMenApocalypse_2016_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='earthandblood.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/EarthAndBlood_2020_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='theshallows.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheShallows_2016_sub_ro.vtt':
                (this.state.playlist.slice(-28)==='thehuntressruneofthedead.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheHuntressRuneOfTheDead_2019_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='highlife.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/HighLife_2018_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='parasite.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Parasite_2019_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='crucibleofthevampire.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/CrucibleOfTheVampire_2019_sub_ro.vtt':
                (this.state.playlist.slice(-8)==='jinn.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Jinn_2018_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='angelhasfallen.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AngelHasFallen_2019_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='aroughdraft.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ARoughDraft_2018_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='coldground.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ColdGround_2017_sub_ro.vtt':
                (this.state.playlist.slice(-9)==='mandy.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Mandy_2018_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='draculauntold.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/DraculaUntold_2014_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='widowswalk.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/WidowsWalk_2019_sub_ro.vtt':
                (this.state.playlist.slice(-6)==='us.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Us_2019_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='therevenant.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheRevenant_2015_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='thedarktower.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheDarkTower_2017_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='apocalypto.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Apocalypto_2006_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='replace.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Replace_2017_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='alienimplant.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AlienImplant_2017_sub_ro.vtt':
                (this.state.playlist.slice(-17)==='fantasticfour.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FantasticFour_2005_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='fantasticfourtwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FantasticFourTwo_2015_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='hercules.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Hercules_2014_sub_ro.vtt':
                (this.state.playlist.slice(-23)==='gijoetheriseofcobra.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GIJoeTheRiseOfCobra_2009_sub_ro.vtt':
                (this.state.playlist.slice(-26)==='captainamericacivilwar.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/CaptainAmericaCivilWar_2016_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='minotaur.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Minotaur_2006_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='krampusorigins.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/KrampusOrigins_2018_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='behindyou.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/BehindYou_2020_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='theunborn.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheUnborn_2020_sub_ro.vtt':
                (this.state.playlist.slice(-28)==='flightsixhundredsixtysix.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/FlightSixHundredSixtySix_2018_sub_ro.vtt':
                (this.state.playlist.slice(-31)==='prideandprejudiceandzombies.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PrideAndPrejudiceAndZombies_2016_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='loveinwinterland.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/LoveInWinterland_2020_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='wintercastle.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/WinterCastle_2019_sub_ro.vtt':
                (this.state.playlist.slice(-20)==='memoirsofageisha.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/MemoirsOfAGeisha_2005_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='sonofsaul.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/SonOfSaul_2015_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='thedouble.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheDouble_2011_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='sgtwillgardner.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/SgtWillGardner_2019_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='wherehandstouch.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/WhereHandsTouch_2018_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='zombies.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Zombies_2017_sub_ro.vtt':
                (this.state.playlist.slice(-18)==='alienvszombies.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AlienVsZombies_2017_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='erniejoe.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ErnieJoe_2019_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='painandglory.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/PainAndGlory_2019_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='afantasticwoman.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/AFantasticWoman_2017_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='stormboy.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/StormBoy_2019_sub_ro.vtt':
                (this.state.playlist.slice(-11)==='thecrow.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheCrow_1994_sub_ro.vtt':
                (this.state.playlist.slice(-22)==='momentumgeneration.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/MomentumGeneration_2018_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='thesecretdaretodream.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheSecretDareToDream_2020_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='ifyouaregone.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/IfYouAreGone_2019_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='hunterkiller.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/HunterKiller_2018_sub_ro.vtt':
                (this.state.playlist.slice(-19)==='ghostintheshell.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/GhostInTheShell_2017_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='replicas.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Replicas_2018_sub_ro.vtt':
                (this.state.playlist.slice(-15)==='beetlejuice.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Beetlejuice_1988_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='monsterhouse.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/MonsterHouse_2006_sub_ro.vtt':
                (this.state.playlist.slice(-10)==='carrie.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Carrie_2013_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='halloween.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Halloween_1978_sub_ro.vtt':
                (this.state.playlist.slice(-6)==='it.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/It_2017_sub_ro.vtt':
                (this.state.playlist.slice(-34)==='transformersrevengeofthefallen.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TransformersRevengeOfTheFallen_2009_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='itchaptertwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ItChapterTwo_2019_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='poseidon.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Poseidon_2006_sub_ro.vtt':
                (this.state.playlist.slice(-12)==='timetrap.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TimeTrap_2017_sub_ro.vtt':
                (this.state.playlist.slice(-25)==='thecloverfieldparadox.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheCloverfieldParadox_2018_sub_ro.vtt':
                (this.state.playlist.slice(-24)==='thetimetravelerswife.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheTimeTravelersWife_2009_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='thegateway.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/TheGateway_2018_sub_ro.vtt':
                (this.state.playlist.slice(-16)==='projectpower.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/ProjectPower_2020_sub_ro.vtt':
                (this.state.playlist.slice(-35)==='nightatthemuseumsecretofthetomb.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/NightAtTheMuseumSecretOfTheTomb_2014_sub_ro.vtt':
                (this.state.playlist.slice(-14)==='passengers.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Passengers_2016_sub_ro.vtt':
                (this.state.playlist.slice(-9)==='venom.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Venom_2018_sub_ro.vtt':
                (this.state.playlist.slice(-8)==='lucy.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Lucy_2014_sub_ro.vtt':
                (this.state.playlist.slice(-9)==='alpha.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Alpha_2018_sub_ro.vtt':
                (this.state.playlist.slice(-13)==='avatartwo.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Avatartwo_2022_sub_ro.vtt':
                (this.state.playlist.slice(-9)==='atlas.mp4'?'https://vasileclaudiu.github.io/reactsopcast/assets/sub/Atlas_2024_sub_ro.vtt':''))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))),
                label: 'Romanian',
                kind: 'captions',
                'default': true
              }],
              }]}
              isAutoPlay={this.state.autostart}
              playerId={this.playerId} // bring in the randomly generated playerId
              playerScript="https://vasileclaudiu.github.io/reactsopcast/assets/js/jwplayer-8.11.3.js"
            />)}
            {this.state.videoplayer===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Avatar_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.videoplayer===true && (<br/>)}
            {this.state.avatar_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Avatar_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.avatar_movie===true && (<br/>)}
            {this.state.gladiator_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Gladiator_2000_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.gladiator_movie===true && (<br/>)}
            {this.state.independanceday_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/IndependenceDay_1996_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.independanceday_movie===true && (<br/>)}
            {this.state.starwarssoloastory_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/StarWarsSoloAStory_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.starwarssoloastory_movie===true && (<br/>)}
            {this.state.intime_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/InTime_2011_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.intime_movie===true && (<br/>)}
            {this.state.bornastar_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BornAStar_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.bornastar_movie===true && (<br/>)}
            {this.state.prettywoman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PrettyWoman_1990_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.prettywoman_movie===true && (<br/>)}
            {this.state.basicinstinct_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BasicInstinct_1992_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.basicinstinct_movie===true && (<br/>)}
            {this.state.basicinstincttwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BasicInstinctTwo_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.basicinstincttwo_movie===true && (<br/>)}
            {this.state.doubleimpact_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/DoubleImpact_1991_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.doubleimpact_movie===true && (<br/>)}
            {this.state.rockyfive_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/RockyFive_1990_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.rockyfive_movie===true && (<br/>)}
            {this.state.thetitan_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheTitan_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thetitan_movie===true && (<br/>)}
            {this.state.thematrixrevolutions_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheMatrixRevolutions_2003_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thematrixrevolutions_movie===true && (<br/>)}
            {this.state.thematrixreloaded_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheMatrixReloaded_2003_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thematrixreloaded_movie===true && (<br/>)}
            {this.state.frozentwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FrozenTwo_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.frozentwo_movie===true && (<br/>)}
            {this.state.oblivion_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Oblivion_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.oblivion_movie===true && (<br/>)}
            {this.state.spiderman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Spiderman_2002_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.spiderman_movie===true && (<br/>)}
            {this.state.spidermantwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Spidermantwo_2004_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.spidermantwo_movie===true && (<br/>)}
            {this.state.legionnaire_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Legionnaire_1998_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.legionnaire_movie===true && (<br/>)}
            {this.state.agooddaytodiehard_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AGoodDaytoDieHard_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.agooddaytodiehard_movie===true && (<br/>)}
            {this.state.thehardcorps_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheHardCorps_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thehardcorps_movie===true && (<br/>)}
            {this.state.irobot_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/IRobot_2004_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.irobot_movie===true && (<br/>)}
            {this.state.robocopthree_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/RoboCopThree_1993_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.robocopthree_movie===true && (<br/>)}
            {this.state.robocop_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/RoboCop_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.robocop_movie===true && (<br/>)}
            {this.state.diehard_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/DieHard_1988_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.diehard_movie===true && (<br/>)}
            {this.state.missionimpossible_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/MissionImpossible_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.missionimpossible_movie===true && (<br/>)}
            {this.state.titanic_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Titanic_1997_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.titanic_movie===true && (<br/>)}
            {this.state.shooter_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Shooter_2007_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.shooter_movie===true && (<br/>)}
            {this.state.troia_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Troia_2004_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.troia_movie===true && (<br/>)}
            {this.state.martian_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Martian_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.martian_movie===true && (<br/>)}
            {this.state.thedayaftertomorow_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheDayAfterTomorow_2004_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thedayaftertomorow_movie===true && (<br/>)}
            {this.state.thorthedarkworld_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ThorTheDarkWorld_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thorthedarkworld_movie===true && (<br/>)}
            {this.state.douamiidoisprezece_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/DouaMiiDoisprezece_2012_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.douamiidoisprezece_movie===true && (<br/>)}
            {this.state.the5thwave_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/The5thWave_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.the5thwave_movie===true && (<br/>)}
            {this.state.godzilla_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Godzilla_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.godzilla_movie===true && (<br/>)}
            {this.state.firstman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FirstMan_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.firstman_movie===true && (<br/>)}
            {this.state.ironman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/IronMan_2008_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ironman_movie===true && (<br/>)}
            {this.state.grizzlyman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GrizzlyMan_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.grizzlyman_movie===true && (<br/>)}
            {this.state.imlegend_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ImLegend_2007_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.imlegend_movie===true && (<br/>)}
            {this.state.thelegendofhercules_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheLegendOfHercules_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thelegendofhercules_movie===true && (<br/>)}
            {this.state.thelegendoftarzan_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheLegendOfTarzan_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thelegendoftarzan_movie===true && (<br/>)}
            {this.state.thelegendofzorro_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheLegendOfZorro_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thelegendofzorro_movie===true && (<br/>)}
            {this.state.fistsoflegend_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FistsOfLegend_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.fistsoflegend_movie===true && (<br/>)}
            {this.state.americanson_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AmericanSon_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.americanson_movie===true && (<br/>)}
            {this.state.firststrike_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FirstStrike_1996_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.firststrike_movie===true && (<br/>)}
            {this.state.anaconda_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Anaconda_1997_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.anaconda_movie===true && (<br/>)}
            {this.state.anacondathree_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AnacondaThree_2008_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.anacondathree_movie===true && (<br/>)}
            {this.state.theedge_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheEdge_1998_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theedge_movie===true && (<br/>)}
            {this.state.countdown_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/CountDown_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.countdown_movie===true && (<br/>)}
            {this.state.theinvisibleman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheInvisibleMan_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theinvisibleman_movie===true && (<br/>)}
            {this.state.invisible_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Invisible_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.invisible_movie===true && (<br/>)}
            {this.state.theweatherman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheWeatherMan_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theweatherman_movie===true && (<br/>)}
            {this.state.ghostrider_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GhostRider_2011_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ghostrider_movie===true && (<br/>)}
            {this.state.firefire_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FireFire_2012_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.firefire_movie===true && (<br/>)}
            {this.state.cityofangels_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/CityOfAngels_1998_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.cityofangels_movie===true && (<br/>)}
            {this.state.constantine_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Constantine_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.constantine_movie===true && (<br/>)}
            {this.state.constantineold_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Constantine_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.constantineold_movie===true && (<br/>)}
            {this.state.stepup_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/StepUp_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.stepup_movie===true && (<br/>)}
            {this.state.supermanreturns_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/SupermanReturns_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.supermanreturns_movie===true && (<br/>)}
            {this.state.adangerousman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ADangerousMan_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.adangerousman_movie===true && (<br/>)}
            {this.state.frozenfever_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FrozenFever_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.frozenfever_movie===true && (<br/>)}
            {this.state.copland_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/CopLand_1997_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.copland_movie===true && (<br/>)}
            {this.state.thefugitive_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheFugitive_1993_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thefugitive_movie===true && (<br/>)}
            {this.state.looper_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Looper_2012_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.looper_movie===true && (<br/>)}
            {this.state.greenzone_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GreenZone_2010_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.greenzone_movie===true && (<br/>)}
            {this.state.warfortheplanetoftheapes_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/WarForThePlanetOfTheApes_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.warfortheplanetoftheapes_movie===true && (<br/>)}
            {this.state.beyondareasonabledoubt_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BeyondAReasonableDoubt_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.beyondareasonabledoubt_movie===true && (<br/>)}
            {this.state.riseoftheplanetoftheapes_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/RiseOfThePlanetOfTheApes_2011_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.riseoftheplanetoftheapes_movie===true && (<br/>)}
            {this.state.goodkill_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GoodKill_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.goodkill_movie===true && (<br/>)}
            {this.state.thehuntingparty_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheHuntingParty_2007_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thehuntingparty_movie===true && (<br/>)}
            {this.state.americansniper_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AmericanSniper_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.americansniper_movie===true && (<br/>)}
            {this.state.criminal_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Criminal_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.criminal_movie===true && (<br/>)}
            {this.state.exodus_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Exodus_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.exodus_movie===true && (<br/>)}
            {this.state.startrekintodarkness_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/StarTrekIntoDarkness_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.startrekintodarkness_movie===true && (<br/>)}
            {this.state.kursk_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Kursk_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.kursk_movie===true && (<br/>)}
            {this.state.war_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/War_2007_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.war_movie===true && (<br/>)}
            {this.state.hartswar_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/HartsWar_2002_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.hartswar_movie===true && (<br/>)}
            {this.state.jungle_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Jungle_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.jungle_movie===true && (<br/>)}
            {this.state.piratesofthecaribbean_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PiratesOfTheCaribbean_2011_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.piratesofthecaribbean_movie===true && (<br/>)}
            {this.state.guardiansofthegalaxy_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GuardiansOfTheGalaxy_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.guardiansofthegalaxy_movie===true && (<br/>)}
            {this.state.guardiansofthegalaxytwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GuardiansOfTheGalaxyTwo_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.guardiansofthegalaxytwo_movie===true && (<br/>)}
            {this.state.sniperthree_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/SniperThree_2004_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.sniperthree_movie===true && (<br/>)}
            {this.state.patriotsday_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PatriotsDay_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.patriotsday_movie===true && (<br/>)}
            {this.state.motherlessbrooklyn_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/MotherlessBrooklyn_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.motherlessbrooklyn_movie===true && (<br/>)}
            {this.state.terminator_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Terminator_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.terminator_movie===true && (<br/>)}
            {this.state.firststriketwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FirstStrikeTwo_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.firststriketwo_movie===true && (<br/>)}
            {this.state.fortysevenmetersdown_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FortySevenMetersDown_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.fortysevenmetersdown_movie===true && (<br/>)}
            {this.state.whitehousedown_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/WhiteHouseDown_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.whitehousedown_movie===true && (<br/>)}
            {this.state.transformers_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Transformers_2007_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.transformers_movie===true && (<br/>)}
            {this.state.stargate_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Stargate_2008_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.stargate_movie===true && (<br/>)}
            {this.state.noah_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Noah_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.noah_movie===true && (<br/>)}
            {this.state.oursoulsatnight_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/OurSoulsAtNight_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.oursoulsatnight_movie===true && (<br/>)}
            {this.state.transformerstwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TransformersTwo_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.transformerstwo_movie===true && (<br/>)}
            {this.state.equalstandard_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/EqualStandard_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.equalstandard_movie===true && (<br/>)}
            {this.state.starwarstheriseofskywalker_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/StarWarsTheRiseOfSkywalker_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.starwarstheriseofskywalker_movie===true && (<br/>)}
            {this.state.perfectsense_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PerfectSense_2011_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.perfectsense_movie===true && (<br/>)}
            {this.state.regardinghenry_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/RegardingHenry_1991_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.regardinghenry_movie===true && (<br/>)}
            {this.state.theimmigrant_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheImmigrant_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theimmigrant_movie===true && (<br/>)}
            {this.state.themazerunner_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheMazeRunner_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.themazerunner_movie===true && (<br/>)}
            {this.state.pointbreak_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PointBreak_1991_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.pointbreak_movie===true && (<br/>)}
            {this.state.threehundred_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ThreeHundred_2007_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.threehundred_movie===true && (<br/>)}
            {this.state.dunkirk_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Dunkirk_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.dunkirk_movie===true && (<br/>)}
            {this.state.threehundredtwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/threehundredtwo_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.threehundredtwo_movie===true && (<br/>)}
            {this.state.insurgent_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Insurgent_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.insurgent_movie===true && (<br/>)}
            {this.state.extinction_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Extinction_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.extinction_movie===true && (<br/>)}
            {this.state.thecore_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheCore_2003_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thecore_movie===true && (<br/>)}
            {this.state.sevenyearsintibet_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/SevenYearsInTibet_1997_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.sevenyearsintibet_movie===true && (<br/>)}
            {this.state.universalsoldier_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/UniversalSoldier_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.universalsoldier_movie===true && (<br/>)}
            {this.state.partyharddieyoung_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PartyHardDieYoung_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.partyharddieyoung_movie===true && (<br/>)}
            {this.state.behindenemylines_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BehindEnemyLines_2001_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.behindenemylines_movie===true && (<br/>)}
            {this.state.alienoverlords_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AlienOverlords_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.alienoverlords_movie===true && (<br/>)}
            {this.state.themummy_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheMummy_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.themummy_movie===true && (<br/>)}
            {this.state.burnout_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BurnOut_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.burnout_movie===true && (<br/>)}
            {this.state.darc_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Darc_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.darc_movie===true && (<br/>)}
            {this.state.elysium_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Elysium_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.elysium_movie===true && (<br/>)}
            {this.state.xmentwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/XMenTwo_2003_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.xmentwo_movie===true && (<br/>)}
            {this.state.iceman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Iceman_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.iceman_movie===true && (<br/>)}
            {this.state.drailed_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/DRailed_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.drailed_movie===true && (<br/>)}
            {this.state.thecorrupted_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheCorrupted_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thecorrupted_movie===true && (<br/>)}
            {this.state.destroyer_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Destroyer_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.destroyer_movie===true && (<br/>)}
            {this.state.aravindasamethaveeraraghava_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AravindaSamethaVeeraRaghava_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.aravindasamethaveeraraghava_movie===true && (<br/>)}
            {this.state.thewheel_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheWheel_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thewheel_movie===true && (<br/>)}
            {this.state.theoutsider_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheOutsider_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theoutsider_movie===true && (<br/>)}
            {this.state.interrogation_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Interrogation_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.interrogation_movie===true && (<br/>)}
            {this.state.momentum_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Momentum_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.momentum_movie===true && (<br/>)}
            {this.state.thecutlass_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheCutlass_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thecutlass_movie===true && (<br/>)}
            {this.state.secretintheireyes_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/SecretInTheirEyes_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.secretintheireyes_movie===true && (<br/>)}
            {this.state.frompariswithlove_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FromParisWithLove_2010_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.frompariswithlove_movie===true && (<br/>)}
            {this.state.insidemanmostwanted_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/InsideManMostWanted_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.insidemanmostwanted_movie===true && (<br/>)}
            {this.state.goyotheboygeneral_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GoyoTheBoyGeneral_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.goyotheboygeneral_movie===true && (<br/>)}
            {this.state.thecurrentwar_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheCurrentWar_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thecurrentwar_movie===true && (<br/>)}
            {this.state.xmendaysoffuturepast_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/XMenDaysOfFuturePast_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.xmendaysoffuturepast_movie===true && (<br/>)}
            {this.state.allegiant_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Allegiant_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.allegiant_movie===true && (<br/>)}
            {this.state.ichi_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Ichi_2008_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ichi_movie===true && (<br/>)}
            {this.state.avpalienvspredator_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AvpAlienVsPredator_2004_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.avpalienvspredator_movie===true && (<br/>)}
            {this.state.kingdomofheaven_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/KingdomOfHeaven_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.kingdomofheaven_movie===true && (<br/>)}
            {this.state.ghostsofwar_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GhostsOfWar_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ghostsofwar_movie===true && (<br/>)}
            {this.state.theplatform_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ThePlatform_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theplatform_movie===true && (<br/>)}
            {this.state.battlescars_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BattleScars_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.battlescars_movie===true && (<br/>)}
            {this.state.bloodandglory_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BloodAndGlory_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.bloodandglory_movie===true && (<br/>)}
            {this.state.bloodfather_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BloodFather_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.bloodfather_movie===true && (<br/>)}
            {this.state.hoursthesecretsoldiersofbenghazi_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/HoursTheSecretSoldiersOfBenghazi_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.hoursthesecretsoldiersofbenghazi_movie===true && (<br/>)}
            {this.state.thefinesthours_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheFinestHours_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thefinesthours_movie===true && (<br/>)}
            {this.state.aux_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Aux_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.aux_movie===true && (<br/>)}
            {this.state.ayogya_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Ayogya_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ayogya_movie===true && (<br/>)}
            {this.state.thedirective_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheDirective_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thedirective_movie===true && (<br/>)}
            {this.state.elchicano_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ElChicano_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.elchicano_movie===true && (<br/>)}
            {this.state.mymother_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/MyMother_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.mymother_movie===true && (<br/>)}
            {this.state.firstlove_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FirstLove_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.firstlove_movie===true && (<br/>)}
            {this.state.drinkslaylove_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/DrinkSlayLove_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.drinkslaylove_movie===true && (<br/>)}
            {this.state.thewholetruth_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheWholeTruth_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thewholetruth_movie===true && (<br/>)}
            {this.state.ashesinthesnow_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AshesInTheSnow_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ashesinthesnow_movie===true && (<br/>)}
            {this.state.capsule_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Capsule_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.capsule_movie===true && (<br/>)}
            {this.state.paloalto_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PaloAlto_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.paloalto_movie===true && (<br/>)}
            {this.state.moffie_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Moffie_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.moffie_movie===true && (<br/>)}
            {this.state.thebeastinthejungle_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheBeastInTheJungle_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thebeastinthejungle_movie===true && (<br/>)}
            {this.state.thebirdcatchersson_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheBirdcatchersSon_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thebirdcatchersson_movie===true && (<br/>)}
            {this.state.bharat_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Bharat_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.bharat_movie===true && (<br/>)}
            {this.state.thewolves_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheWolves_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thewolves_movie===true && (<br/>)}
            {this.state.godblessthebrokenroad_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GodBlessTheBrokenRoad_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.godblessthebrokenroad_movie===true && (<br/>)}
            {this.state.thespacewalker_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheSpacewalker_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thespacewalker_movie===true && (<br/>)}
            {this.state.justiceleaguevsthefatalfive_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/JusticeLeagueVsTheFatalFive_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.justiceleaguevsthefatalfive_movie===true && (<br/>)}
            {this.state.xmenapocalypse_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/XMenApocalypse_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.xmenapocalypse_movie===true && (<br/>)}
            {this.state.earthandblood_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/EarthAndBlood_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.earthandblood_movie===true && (<br/>)}
            {this.state.theshallows_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheShallows_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theshallows_movie===true && (<br/>)}
            {this.state.thehuntressruneofthedead_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheHuntressRuneOfTheDead_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thehuntressruneofthedead_movie===true && (<br/>)}
            {this.state.highlife_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/HighLife_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.highlife_movie===true && (<br/>)}
            {this.state.parasite_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Parasite_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.parasite_movie===true && (<br/>)}
            {this.state.crucibleofthevampire_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/CrucibleOfTheVampire_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.crucibleofthevampire_movie===true && (<br/>)}
            {this.state.jinn_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Jinn_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.jinn_movie===true && (<br/>)}
            {this.state.angelhasfallen_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AngelHasFallen_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.angelhasfallen_movie===true && (<br/>)}
            {this.state.aroughdraft_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ARoughDraft_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.aroughdraft_movie===true && (<br/>)}
            {this.state.coldground_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ColdGround_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.coldground_movie===true && (<br/>)}
            {this.state.mandy_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Mandy_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.mandy_movie===true && (<br/>)}
            {this.state.draculauntold_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/DraculaUntold_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.draculauntold_movie===true && (<br/>)}
            {this.state.widowswalk_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/WidowsWalk_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.widowswalk_movie===true && (<br/>)}
            {this.state.us_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Us_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.us_movie===true && (<br/>)}
            {this.state.therevenant_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheRevenant_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.therevenant_movie===true && (<br/>)}
            {this.state.thedarktower_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheDarkTower_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thedarktower_movie===true && (<br/>)}
            {this.state.apocalypto_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Apocalypto_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.apocalypto_movie===true && (<br/>)}
            {this.state.replace_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Replace_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.replace_movie===true && (<br/>)}
            {this.state.alienimplant_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AlienImplant_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.alienimplant_movie===true && (<br/>)}
            {this.state.fantasticfour_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FantasticFour_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.fantasticfour_movie===true && (<br/>)}
            {this.state.fantasticfourtwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FantasticFourTwo_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.fantasticfourtwo_movie===true && (<br/>)}
            {this.state.hercules_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Hercules_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.hercules_movie===true && (<br/>)}
            {this.state.gijoetheriseofcobra_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GIJoeTheRiseOfCobra_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.gijoetheriseofcobra_movie===true && (<br/>)}
            {this.state.captainamericacivilwar_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/CaptainAmericaCivilWar_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.captainamericacivilwar_movie===true && (<br/>)}
            {this.state.minotaur_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Minotaur_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.minotaur_movie===true && (<br/>)}
            {this.state.krampusorigins_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/KrampusOrigins_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.krampusorigins_movie===true && (<br/>)}
            {this.state.behindyou_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/BehindYou_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.behindyou_movie===true && (<br/>)}
            {this.state.theunborn_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheUnborn_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.theunborn_movie===true && (<br/>)}
            {this.state.flightsixhundredsixtysix_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/FlightSixHundredSixtySix_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.flightsixhundredsixtysix_movie===true && (<br/>)}
            {this.state.prideandprejudiceandzombies_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PrideAndPrejudiceAndZombies_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.prideandprejudiceandzombies_movie===true && (<br/>)}
            {this.state.loveinwinterland_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/LoveInWinterland_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.loveinwinterland_movie===true && (<br/>)}
            {this.state.wintercastle_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/WinterCastle_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.wintercastle_movie===true && (<br/>)}
            {this.state.memoirsofageisha_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/MemoirsOfAGeisha_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.memoirsofageisha_movie===true && (<br/>)}
            {this.state.sonofsaul_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/SonOfSaul_2015_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.sonofsaul_movie===true && (<br/>)}
            {this.state.thedouble_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheDuble_2011_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thedouble_movie===true && (<br/>)}
            {this.state.sgtwillgardner_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/SgtWillGardner_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.sgtwillgardner_movie===true && (<br/>)}
            {this.state.wherehandstouch_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/WhereHandsTouch_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.wherehandstouch_movie===true && (<br/>)}
            {this.state.zombies_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Zombies_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.zombies_movie===true && (<br/>)}
            {this.state.alienvszombies_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AlienVsZombies_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.alienvszombies_movie===true && (<br/>)}
            {this.state.erniejoe_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ErnieJoe_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.erniejoe_movie===true && (<br/>)}
            {this.state.painandglory_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/PainAndGlory_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.painandglory_movie===true && (<br/>)}
            {this.state.afantasticwoman_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/AFantasticWoman_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.afantasticwoman_movie===true && (<br/>)}
            {this.state.stormboy_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/StormBoy_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.stormboy_movie===true && (<br/>)}
            {this.state.thecrow_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheCrow_1994_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thecrow_movie===true && (<br/>)}
            {this.state.momentumgeneration_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/MomentumGeneration_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.momentumgeneration_movie===true && (<br/>)}
            {this.state.thesecretdaretodream_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheSecretDareToDream_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thesecretdaretodream_movie===true && (<br/>)}
            {this.state.ifyouaregone_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/IfYouAreGone_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ifyouaregone_movie===true && (<br/>)}
            {this.state.hunterkiller_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/HunterKiller_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.hunterkiller_movie===true && (<br/>)}
            {this.state.ghostintheshell_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/GhostInTheShell_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.ghostintheshell_movie===true && (<br/>)}
            {this.state.replicas_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Replicas_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.replicas_movie===true && (<br/>)}
            {this.state.beetlejuice_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Beetlejuice_1988_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.beetlejuice_movie===true && (<br/>)}
            {this.state.monsterhouse_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/MonsterHouse_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.monsterhouse_movie===true && (<br/>)}
            {this.state.carrie_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Carrie_2013_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.carrie_movie===true && (<br/>)}
            {this.state.corpsebride_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/CorpseBride_2005_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.corpsebride_movie===true && (<br/>)}
            {this.state.halloween_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Halloween_1978_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.halloween_movie===true && (<br/>)}
            {this.state.it_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/It_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.it_movie===true && (<br/>)}
            {this.state.transformersrevengeofthefallen_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TransformersRevengeOfTheFallen_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.transformersrevengeofthefallen_movie===true && (<br/>)}
            {this.state.itchaptertwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ItChapterTwo_2019_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.itchaptertwo_movie===true && (<br/>)}
            {this.state.poseidon_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Poseidon_2006_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.poseidon_movie===true && (<br/>)}
            {this.state.timetrap_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TimeTrap_2017_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.timetrap_movie===true && (<br/>)}
            {this.state.thecloverfieldparadox_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheCloverfieldParadox_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thecloverfieldparadox_movie===true && (<br/>)}
            {this.state.thetimetravelerswife_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheTimeTravelersWife_2009_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thetimetravelerswife_movie===true && (<br/>)}
            {this.state.thegateway_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/TheGateway_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.thegateway_movie===true && (<br/>)}
            {this.state.projectpower_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/ProjectPower_2020_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.projectpower_movie===true && (<br/>)}
            {this.state.nightatthemuseumsecretofthetomb_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/NightAtTheMuseumSecretOfTheTomb_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.nightatthemuseumsecretofthetomb_movie===true && (<br/>)}
            {this.state.passengers_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Passengers_2016_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.passengers_movie===true && (<br/>)}
            {this.state.venom_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Venom_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.venom_movie===true && (<br/>)}
            {this.state.lucy_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Lucy_2014_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.lucy_movie===true && (<br/>)}
            {this.state.alpha_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Alpha_2018_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.alpha_movie===true && (<br/>)}
            {this.state.avatartwo_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Avatartwo_2022_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.avatartwo_movie===true && (<br/>)}
            {this.state.atlas_movie===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="metadata" style={videoplayerstyle} src={this.state.playlist} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                <track label="Romanian" kind="subtitles" src="assets/sub/Atlas_2024_sub_ro.vtt" srcLang="ro" default />
                </video>)}
            {this.state.atlas_movie===true && (<br/>)}
            {this.state.videoadultplayer===true && (<video width={this.state.width} height="500" id="my-video-stream" controls="controls" preload="auto" style={videoplayerstyle} src={this.state.playlist.slice(0,this.state.playlist.length-19)} autoPlay>
                <source src="vid/vid.mp4" type="video/mp4"/>
                </video>)}
            {this.state.videoadultplayer===true && (<br/>)}
            {this.state.videojsshow===true && (<VideoJS options={this.state.videoJsOptions} onReady={this.handlePlayerReady} />)}
<div className="row"> 
<label>Selectati categoria:</label>{this.state.denumireselectie !==''?(<div className="mx-auto">Film Selectat:{this.state.denumireselectie}</div>):''}

<select id="txUrlCateg" name="txUrlCateg" className="custom-select" value={this.state.jwtcategories} onChange={e => this.setSelectedOptionjwtcategory(e.target.value)}>
    <option>Selectati categoria</option>
    {this.state.jwtcategory.map((channel) => (
    <option value={channel.id} key={channel.id}>{channel.title}</option>
    ))}
    <option value="0" key="0">Toate</option>
</select><br/>
<label>Selectati sursa:</label>

<select id="txUrl" name="txUrl" className="custom-select" value={this.state.playlist} onChange={e => this.setSelectedOption(e.target.value)}>
    <option>Selectati sursa</option>
    {this.state.channels.map((channel) => (
    <option value={channel.adresa}  key={channel.id}>{channel.denumire}</option>
    ))}
</select><br/>
<label htmlFor="inputman">Input Manual</label>
<input id="inputman" type="text" className="form-control" value={this.state.playlist} onChange={e => this.setSelectedOption(e.target.value)}></input>
<div className="radio-buttons" style={divradiobutons}>
    <input type="radio" id="sursa1" name="sursa" checked={this.state.radiocheckedone} value="sursa1" onChange={this.setradio} />Sursa 1
    <input type="radio" id="sursa2" name="sursa" checked={this.state.radiocheckedtwo} value="sursa2" onChange={this.setradio} />Sursa 2
    <input type="radio" id="sursa3" name="sursa" checked={this.state.radiocheckedthree} value="sursa3" onChange={this.setradio} />Sursa 3
    <input type="radio" id="sursa4" name="sursa" checked={this.state.radiocheckedfour} value="sursa4" onChange={this.setradio} />Sursa 4
  </div>
</div>
<label htmlFor="rezumat">Rezumat:</label><br/>
    <div className="row"><div className="rezumat" style={rezumatstyle}>{this.state.rezumat}</div></div>
            </div>
            <hr style={lasthrstyle}/>
          </main>  
        )
    }
}